import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CustomFieldsSection from './CustomFieldsSection';
import AdminHeader from '../components/AdminHeader';
import SuccessPopup from '../components/SuccessPopup';
import StatusAutomationModal from '../components/StatusAutomationModal';

function Admin() {
  const user = JSON.parse(localStorage.getItem('user'));
  const handleLogout = () => {
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  // Quill editor modules configuration
  const quillModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ]
  };

  const quillFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'color', 'background',
    'align',
    'link'
  ];

  const [activeTab, setActiveTab] = useState('categories');
  const [adminSidebarOpen, setAdminSidebarOpen] = useState(false);
  const [adminSidebarClosing, setAdminSidebarClosing] = useState(false);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [showProductForm, setShowProductForm] = useState(false);
  const [inventoryExpanded, setInventoryExpanded] = useState(false);
  const [ordersExpanded, setOrdersExpanded] = useState(false);
  const [usersExpanded, setUsersExpanded] = useState(false);
  const [areasExpanded, setAreasExpanded] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const [editCategoryName, setEditCategoryName] = useState('');
  const [showDeleteCategoryModal, setShowDeleteCategoryModal] = useState(false);
  const [deletingCategory, setDeletingCategory] = useState(null);
  const [showDeleteProductModal, setShowDeleteProductModal] = useState(false);
  const [deletingProduct, setDeletingProduct] = useState(null);
  const [showDeleteOrderModal, setShowDeleteOrderModal] = useState(false);
  const [deletingOrder, setDeletingOrder] = useState(null);
  const [categoryName, setCategoryName] = useState('');
  const [showEditFieldModal, setShowEditFieldModal] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const [editFieldLabel, setEditFieldLabel] = useState('');
  const [showEditOrderModal, setShowEditOrderModal] = useState(false);
  const [editingOrder, setEditingOrder] = useState(null);
  const [editOrderStatus, setEditOrderStatus] = useState('');
  const [productData, setProductData] = useState({
    name: '',
    description: '',
    price: '',
    previous_price: '',
    stock: '',
    image: '',
    images: [],
    category: '',
    part_type: '',
    size: '',
    brand: '',
    usage: '',
    material: '',
    weight: '',
    model_number: '',
    packaging_size: '',
    packaging_type: '',
    equipment_type: '',
    warranty: '',
    return_policy: '',
    in_stock: true
  });
  const [imageMode, setImageMode] = useState('url');
  const [showCropModal, setShowCropModal] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ unit: '%', x: 5, y: 5, width: 90, height: 90, aspect: 4/3 });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [imageRef, setImageRef] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [editImageMode, setEditImageMode] = useState('url');
  const [isEditingImage, setIsEditingImage] = useState(false);
  const [urlImageForCrop, setUrlImageForCrop] = useState('');
  const [customFields, setCustomFields] = useState([]);
  const [showFieldManager, setShowFieldManager] = useState(false);
  const [newFieldName, setNewFieldName] = useState('');
  const [newFieldType, setNewFieldType] = useState('text');
  const [defaultFields, setDefaultFields] = useState([
    { id: 'name', name: 'name', label: 'Product Name', type: 'text', isDefault: true, required: true },
    { id: 'description', name: 'description', label: 'Description', type: 'textarea', isDefault: true, required: true },
    { id: 'price', name: 'price', label: 'Price (Rs.)', type: 'number', isDefault: true, required: true },
    { id: 'stock', name: 'stock', label: 'Stock', type: 'number', isDefault: true, required: true },
    { id: 'image', name: 'image', label: 'Product Image', type: 'file', isDefault: true, required: true },
    { id: 'category', name: 'category', label: 'Category', type: 'select', isDefault: true, required: true },
    { id: 'part_type', name: 'part_type', label: 'Part Type', type: 'text', isDefault: true },
    { id: 'size', name: 'size', label: 'Size', type: 'text', isDefault: true },
    { id: 'brand', name: 'brand', label: 'Brand', type: 'text', isDefault: true },
    { id: 'usage', name: 'usage', label: 'Usage/Application', type: 'text', isDefault: true },
    { id: 'material', name: 'material', label: 'Material', type: 'text', isDefault: true },
    { id: 'weight', name: 'weight', label: 'Weight', type: 'text', isDefault: true },
    { id: 'model_number', name: 'model_number', label: 'Model Name/Number', type: 'text', isDefault: true },
    { id: 'packaging_size', name: 'packaging_size', label: 'Packaging Size', type: 'text', isDefault: true },
    { id: 'packaging_type', name: 'packaging_type', label: 'Packaging Type', type: 'text', isDefault: true },
    { id: 'equipment_type', name: 'equipment_type', label: 'Equipment Type', type: 'text', isDefault: true }
  ]);
  const [hiddenFields, setHiddenFields] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [selectedStatusFilter, setSelectedStatusFilter] = useState('all');
  const [orderSearchTerm, setOrderSearchTerm] = useState('');
  const [selectedProvinceFilter, setSelectedProvinceFilter] = useState('');
  const [selectedCityFilter, setSelectedCityFilter] = useState('');
  const [selectedDistrictFilter, setSelectedDistrictFilter] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [deletingUser, setDeletingUser] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [editUserName, setEditUserName] = useState('');
  const [editUserEmail, setEditUserEmail] = useState('');
  const [editUserPassword, setEditUserPassword] = useState('');
  const [editUserRole, setEditUserRole] = useState('');
  const [provinces, setProvinces] = useState([]);
  const [provinceName, setProvinceName] = useState('');
  const [cities, setCities] = useState([]);
  const [cityName, setCityName] = useState('');
  const [selectedProvince, setSelectedProvince] = useState('');
  const [districts, setDistricts] = useState([]);
  const [districtName, setDistrictName] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [editingProvince, setEditingProvince] = useState(null);
  const [editingCity, setEditingCity] = useState(null);
  const [editingDistrict, setEditingDistrict] = useState(null);
  const [slides, setSlides] = useState([]);
  const [showSlideForm, setShowSlideForm] = useState(false);
  const [editingSlide, setEditingSlide] = useState(null);
  const [slideData, setSlideData] = useState({ title: '', subtitle: '', description: '', button_text: 'SHOP NOW', image: '', bg_color: '#f5f5f5', sort_order: 0, is_active: 1 });
  const [slideImageFile, setSlideImageFile] = useState(null);
  const [feedbacks, setFeedbacks] = useState([]);
  const [showDeleteFeedbackModal, setShowDeleteFeedbackModal] = useState(false);
  const [deletingFeedback, setDeletingFeedback] = useState(null);
  const [showEditFeedbackModal, setShowEditFeedbackModal] = useState(false);
  const [editingFeedback, setEditingFeedback] = useState(null);
  const [editFeedbackImage, setEditFeedbackImage] = useState(null);
  const [showStatusAutomationModal, setShowStatusAutomationModal] = useState(false);

  useEffect(() => {
    loadCategories();
    loadProducts();
    loadOrders();
    loadCustomFields();
    loadProvinces();
    loadUsers();
    loadFeedbacks();
    loadSlides();
    
    // Auto-process status automation every 5 minutes when admin panel is open
    const autoProcessInterval = setInterval(async () => {
      try {
        const result = await api.processStatusAutomation();
        if (result.success && result.updated_count > 0) {
          console.log(`Auto-processed ${result.updated_count} orders`);
          loadOrders(); // Refresh orders if any were updated
        }
      } catch (error) {
        console.error('Auto-process error:', error);
      }
    }, 5 * 60 * 1000); // 5 minutes

    // Cleanup interval on unmount
    return () => clearInterval(autoProcessInterval);
  }, []);

  const loadCategories = async () => {
    const data = await api.getCategories();
    setCategories(data);
  };

  const loadProducts = async () => {
    try {
      const response = await fetch(`${api.baseURL}/products.php?all=true`);
      const data = await response.json();
      if (Array.isArray(data)) {
        setProducts(data);
      } else if (data.products && Array.isArray(data.products)) {
        setProducts(data.products);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error('Error loading products:', error);
      setProducts([]);
    }
  };

  const loadOrders = async () => {
    try {
      const data = await api.getAllOrders();
      setOrders(data || []);
    } catch (error) {
      console.error('Error loading orders:', error);
      setOrders([]);
    }
  };

  const loadProvinces = async () => {
    const result = await api.getProvinces();
    if (result.success && Array.isArray(result.data)) {
      setProvinces(result.data);
    } else {
      setProvinces([]);
    }
  };

  const loadUsers = async () => {
    try {
      const data = await api.getUsers();
      setUsers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error loading users:', error);
      setUsers([]);
    }
  };

  const loadSlides = async () => {
    try {
      const res = await api.getSlides();
      setSlides(res.data || []);
    } catch (e) { setSlides([]); }
  };

  const handleCreateSlide = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(slideData).forEach(([k, v]) => formData.append(k, v));
    if (slideImageFile) formData.append('image', slideImageFile);
    const res = await api.createSlide(formData);
    if (res.success) {
      setSlideData({ title: '', subtitle: '', description: '', button_text: 'SHOP NOW', image: '', bg_color: '#f5f5f5', sort_order: 0, is_active: 1 });
      setSlideImageFile(null);
      setShowSlideForm(false);
      setSuccessMessage('Slide created successfully!');
      setShowSuccessPopup(true);
      loadSlides();
    } else alert('Failed: ' + res.message);
  };

  const handleUpdateSlide = async (e) => {
    e.preventDefault();
    const res = await api.updateSlide(editingSlide.id, editingSlide);
    if (res.success) {
      setEditingSlide(null);
      setSuccessMessage('Slide updated successfully!');
      setShowSuccessPopup(true);
      loadSlides();
    } else alert('Failed to update slide');
  };

  const handleDeleteSlide = async (id) => {
    if (!window.confirm('Delete this slide?')) return;
    const res = await api.deleteSlide(id);
    if (res.success) {
      setSuccessMessage('Slide deleted successfully!');
      setShowSuccessPopup(true);
      loadSlides();
    }
  };

  const loadFeedbacks = async () => {
    try {
      const response = await fetch(`${api.baseURL}/feedback.php`);
      const result = await response.json();
      if (result.success) {
        setFeedbacks(result.data || []);
      }
    } catch (error) {
      console.error('Error loading feedbacks:', error);
    }
  };

  const closeAdminSidebar = () => {
    setAdminSidebarClosing(true);
    setTimeout(() => {
      setAdminSidebarOpen(false);
      setAdminSidebarClosing(false);
    }, 300);
  };

  const handleCreateProvince = async (e) => {
    e.preventDefault();
    if (!window.confirm('Create this province?')) return;
    const result = await api.createProvince(provinceName);
    if (result.success) {
      setProvinceName('');
      setSuccessMessage('Province created successfully!');
      setShowSuccessPopup(true);
      loadProvinces();
    } else {
      alert('Failed to create province');
    }
  };

  const handleDeleteProvince = async (id) => {
    if (window.confirm('Delete this province?')) {
      const result = await api.deleteProvince(id);
      if (result.success) {
        setSuccessMessage('Province deleted successfully!');
        setShowSuccessPopup(true);
        loadProvinces();
      }
    }
  };

  const handleCreateCity = async (e) => {
    e.preventDefault();
    if (!selectedProvince) {
      alert('Select a province');
      return;
    }
    if (!window.confirm('Create this city?')) return;
    const result = await api.createCity(selectedProvince, cityName);
    if (result.success) {
      setCityName('');
      setSelectedProvince('');
      setSuccessMessage('City created successfully!');
      setShowSuccessPopup(true);
      loadProvinces();
    } else {
      alert('Failed to create city');
    }
  };

  const handleDeleteCity = async (id) => {
    if (window.confirm('Delete this city?')) {
      const result = await api.deleteCity(id);
      if (result.success) {
        setSuccessMessage('City deleted successfully!');
        setShowSuccessPopup(true);
        loadProvinces();
      }
    }
  };

  const handleCreateDistrict = async (e) => {
    e.preventDefault();
    if (!selectedCity) {
      alert('Select a city');
      return;
    }
    if (!window.confirm('Create this district?')) return;
    const result = await api.createDistrict(selectedCity, districtName);
    if (result.success) {
      setDistrictName('');
      setSelectedCity('');
      setSuccessMessage('District created successfully!');
      setShowSuccessPopup(true);
      loadProvinces();
    } else {
      alert('Failed to create district');
    }
  };

  const loadCustomFields = async () => {
    try {
      const result = await api.getCustomFields();
      if (result.success && Array.isArray(result.data)) {
        setCustomFields(result.data);
      } else {
        setCustomFields([]);
      }
    } catch (error) {
      console.error('Error loading custom fields:', error);
      setCustomFields([]);
    }
  };

  const handleDeleteDistrict = async (id) => {
    if (window.confirm('Delete this district?')) {
      const result = await api.deleteDistrict(id);
      if (result.success) {
        setSuccessMessage('District deleted successfully!');
        setShowSuccessPopup(true);
        loadProvinces();
      }
    }
  };

  const handleEditProvince = async (id, name, newId = null) => {
    const result = await api.updateProvince(id, name, newId);
    if (result.success) {
      setEditingProvince(null);
      setSuccessMessage('Province updated successfully!');
      setShowSuccessPopup(true);
      loadProvinces();
    }
  };

  const handleEditCity = async (id, name) => {
    const result = await api.updateCity(id, name);
    if (result.success) {
      setEditingCity(null);
      setSuccessMessage('City updated successfully!');
      setShowSuccessPopup(true);
      loadProvinces();
    }
  };

  const handleEditDistrict = async (id, name) => {
    const result = await api.updateDistrict(id, name);
    if (result.success) {
      setEditingDistrict(null);
      setSuccessMessage('District updated successfully!');
      setShowSuccessPopup(true);
      loadProvinces();
    }
  };

  useEffect(() => {
    if (provinces.length > 0) {
      api.getCities().then(result => {
        if (result.success && Array.isArray(result.data)) {
          setCities(result.data);
        } else {
          setCities([]);
        }
      });
      api.getDistricts().then(result => {
        if (result.success && Array.isArray(result.data)) {
          setDistricts(result.data);
        } else {
          setDistricts([]);
        }
      });
    }
  }, [provinces]);

  const saveCustomFields = async (fields) => {
    // No longer needed - fields are saved to database
    setCustomFields(fields);
  };

  const handleAddCustomField = async () => {
    if (!newFieldName) {
      alert('Please enter field name');
      return;
    }
    const result = await api.createCustomField(newFieldName, newFieldName.charAt(0).toUpperCase() + newFieldName.slice(1), newFieldType);
    if (result.success) {
      setNewFieldName('');
      setNewFieldType('text');
      setSuccessMessage('Field added successfully!');
      setShowSuccessPopup(true);
      loadCustomFields();
    } else {
      alert('Failed to add field: ' + (result.message || 'Unknown error'));
    }
  };

  const handleDeleteCustomField = async (fieldId) => {
    if (window.confirm('Delete this field?')) {
      const result = await api.deleteCustomField(fieldId);
      if (result.success) {
        setSuccessMessage('Field deleted successfully!');
        setShowSuccessPopup(true);
        loadCustomFields();
      } else {
        alert('Failed to delete field');
      }
    }
  };

  const handleToggleDefaultField = (fieldId) => {
    const updated = hiddenFields.includes(fieldId)
      ? hiddenFields.filter(id => id !== fieldId)
      : [...hiddenFields, fieldId];
    localStorage.setItem('hiddenFields', JSON.stringify(updated));
    setHiddenFields(updated);
    alert('Field visibility updated! Switch to Create Product tab to see changes.');
  };

  const handleEditFieldLabel = (field, isDefault) => {
    setEditingField({ ...field, isDefault });
    setEditFieldLabel(field.label);
    setShowEditFieldModal(true);
  };

  const handleUpdateFieldLabel = async (e) => {
    e.preventDefault();
    if (editingField.isDefault) {
      const updated = defaultFields.map(f => 
        f.id === editingField.id ? {...f, label: editFieldLabel} : f
      );
      setDefaultFields(updated);
      localStorage.setItem('defaultFields', JSON.stringify(updated));
    } else {
      const result = await api.updateCustomField(editingField.id, editFieldLabel, editingField.type, true);
      if (result.success) {
        loadCustomFields();
      } else {
        alert('Failed to update field');
        return;
      }
    }
    setShowEditFieldModal(false);
    setEditingField(null);
    setEditFieldLabel('');
    setSuccessMessage('Field label updated successfully!');
    setShowSuccessPopup(true);
  };

  const handleStatusChange = async (orderId, newStatus) => {
    const result = await api.updateOrderStatus(orderId, newStatus);
    if (result.success) {
      setSuccessMessage('Order status updated successfully!');
      setShowSuccessPopup(true);
      loadOrders();
    } else {
      alert('Failed to update status: ' + result.message);
    }
  };

  const handleViewOrder = async (order) => {
    const orderDetails = await api.getOrderDetails(order.id);
    setSelectedOrder(orderDetails);
    setShowOrderModal(true);
  };

  const handleEditOrder = async (order) => {
    const orderDetails = await api.getOrderDetails(order.id);
    setEditingOrder(orderDetails);
    setEditOrderStatus(orderDetails.status);
    setShowEditOrderModal(true);
  };

  const handleUpdateOrder = async (e) => {
    e.preventDefault();
    setShowEditOrderModal(false);
    setEditingOrder(null);
    setEditOrderStatus('');
    setSuccessMessage('Order updated successfully!');
    setShowSuccessPopup(true);
    loadOrders();
  };

  const handleDeleteOrder = (order) => {
    setDeletingOrder(order);
    setShowDeleteOrderModal(true);
  };

  const confirmDeleteOrder = async () => {
    const result = await api.deleteOrder(deletingOrder.id);
    if (result.success) {
      setShowDeleteOrderModal(false);
      setDeletingOrder(null);
      setSuccessMessage('Order deleted successfully!');
      setShowSuccessPopup(true);
      loadOrders();
    } else {
      alert('Failed to delete order');
    }
  };

  const handleDeleteProduct = (product) => {
    setDeletingProduct(product);
    setShowDeleteProductModal(true);
  };

  const confirmDeleteProduct = async () => {
    const result = await api.deleteProduct(deletingProduct.id);
    if (result.success) {
      setShowDeleteProductModal(false);
      setDeletingProduct(null);
      setSuccessMessage('Product deleted successfully!');
      setShowSuccessPopup(true);
      loadProducts();
    } else {
      alert('Failed to delete product');
    }
  };

  const handleUpdateProduct = async (e) => {
    e.preventDefault();
    if (!window.confirm('Update this product?')) return;
    
    // Ensure images is an array before stringifying
    let imagesArray = [];
    if (Array.isArray(editingProduct.images)) {
      imagesArray = editingProduct.images;
    } else if (editingProduct.images && typeof editingProduct.images === 'string') {
      try {
        imagesArray = JSON.parse(editingProduct.images);
      } catch (e) {
        imagesArray = [];
      }
    }
    
    console.log('Updating product:', editingProduct);
    console.log('Images array to save:', imagesArray);
    
    const productToUpdate = {
      ...editingProduct,
      images: JSON.stringify(imagesArray)
    };
    
    const result = await api.updateProduct(editingProduct.id, productToUpdate);
    console.log('Update result:', result);
    if (result.success) {
      setShowEditModal(false);
      setEditingProduct(null);
      await loadProducts();
      setSuccessMessage('Product updated successfully!');
      setShowSuccessPopup(true);
    } else {
      alert('Failed to update: ' + (result.message || 'Unknown error'));
    }
  };

  const handleDeleteCategory = (category) => {
    setDeletingCategory(category);
    setShowDeleteCategoryModal(true);
  };

  const confirmDeleteCategory = async () => {
    const result = await api.deleteCategory(deletingCategory.id);
    if (result.success) {
      setShowDeleteCategoryModal(false);
      setDeletingCategory(null);
      setSuccessMessage('Category deleted successfully!');
      setShowSuccessPopup(true);
      loadCategories();
    } else {
      alert('Failed to delete category');
    }
  };

  const handleEditCategory = (category) => {
    setEditingCategory(category);
    setEditCategoryName(category.name);
    setShowEditCategoryModal(true);
  };

  const handleUpdateCategory = async (e) => {
    e.preventDefault();
    if (!window.confirm('Update this category?')) return;
    const result = await api.updateCategory(editingCategory.id, editCategoryName);
    if (result.success) {
      setShowEditCategoryModal(false);
      setEditingCategory(null);
      setEditCategoryName('');
      setSuccessMessage('Category updated successfully!');
      setShowSuccessPopup(true);
      loadCategories();
    } else {
      alert('Failed to update category');
    }
  };

  const handleCreateCategory = async (e) => {
    e.preventDefault();
    if (!window.confirm('Create this category?')) return;
    const result = await api.createCategory(categoryName);
    if (result.success) {
      setCategoryName('');
      setShowCategoryForm(false);
      setSuccessMessage('Category created successfully!');
      setShowSuccessPopup(true);
      loadCategories();
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUrlImageCrop = () => {
    if (!urlImageForCrop) {
      alert('Please enter image URL');
      return;
    }
    // Create a proxy image to avoid CORS issues
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      setImageSrc(urlImageForCrop);
      setIsEditingImage(false);
      setShowCropModal(true);
    };
    img.onerror = () => {
      alert('Failed to load image. Please check the URL or try uploading instead.');
    };
    img.src = urlImageForCrop;
  };

  const getCroppedImg = () => {
    if (!completedCrop || !imageRef) return;
    const canvas = document.createElement('canvas');
    const scaleX = imageRef.naturalWidth / imageRef.width;
    const scaleY = imageRef.naturalHeight / imageRef.height;
    canvas.width = completedCrop.width;
    canvas.height = completedCrop.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(imageRef, completedCrop.x * scaleX, completedCrop.y * scaleY, completedCrop.width * scaleX, completedCrop.height * scaleY, 0, 0, completedCrop.width, completedCrop.height);
    return new Promise((resolve) => {
      canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.9);
    });
  };

  const handleCropComplete = async () => {
    const croppedBlob = await getCroppedImg();
    if (croppedBlob) {
      const file = new File([croppedBlob], 'cropped.jpg', { type: 'image/jpeg' });
      const result = await api.uploadImage(file);
      if (result.success) {
        if (isEditingImage) {
          let currentImages = [];
          try {
            if (Array.isArray(editingProduct.images)) {
              currentImages = editingProduct.images;
            } else if (editingProduct.images && typeof editingProduct.images === 'string') {
              currentImages = JSON.parse(editingProduct.images);
            }
          } catch (e) {
            currentImages = [];
          }
          const newImages = [...currentImages, result.url];
          setEditingProduct({ 
            ...editingProduct, 
            image: currentImages.length === 0 ? result.url : (editingProduct.image || result.url),
            images: newImages
          });
          setIsEditingImage(false);
        } else {
          const currentImages = productData.images || [];
          const newImages = [...currentImages, result.url];
          setProductData({ 
            ...productData, 
            image: currentImages.length === 0 ? result.url : productData.image,
            images: newImages
          });
        }
        setShowCropModal(false);
        setImageSrc(null);
        setZoom(1);
        setUrlImageForCrop('');
        alert('Image added!');
      } else {
        alert('Upload failed: ' + result.message);
      }
    }
  };

  const handleEditImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setIsEditingImage(true);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCreateProduct = async (e) => {
    e.preventDefault();
    
    if (!productData.image && imageMode === 'upload') {
      alert('Please upload product image');
      return;
    }
    
    if (!productData.image && imageMode === 'url' && !urlImageForCrop) {
      alert('Please provide product image URL');
      return;
    }

    if (!window.confirm('Create this product?')) return;

    // If URL mode and image not set yet, use the URL directly
    const finalProductData = {...productData};
    if (imageMode === 'url' && !productData.image && urlImageForCrop) {
      finalProductData.image = urlImageForCrop;
    }
    
    const result = await api.createProduct(finalProductData);
    if (result.success) {
      setProductData({ name: '', description: '', price: '', previous_price: '', stock: '', image: '', category: '', part_type: '', size: '', brand: '', usage: '', material: '', weight: '', model_number: '', packaging_size: '', packaging_type: '', equipment_type: '', warranty: '', return_policy: '' });
      setUrlImageForCrop('');
      setShowProductForm(false);
      setSuccessMessage('Product created successfully!');
      setShowSuccessPopup(true);
      loadProducts();
    } else {
      alert('Failed to create product: ' + (result.message || 'Unknown error'));
    }
  };

  return (
    <>
      <AdminHeader user={user} onLogout={handleLogout} />
      <button 
        className="admin-mobile-toggle"
        onClick={() => setAdminSidebarOpen(!adminSidebarOpen)}
        style={{
          display: 'none',
          position: 'fixed',
          top: '80px',
          left: '20px',
          zIndex: 999,
          background: '#1a1a2e',
          color: '#ffc107',
          border: 'none',
          borderRadius: '4px',
          padding: '10px 15px',
          fontSize: '20px',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
        }}
      >
        ☰
      </button>
      <div className="admin-layout">
      <aside className="admin-sidebar" style={{
        transform: adminSidebarOpen ? 'translateX(0)' : '',
        animation: adminSidebarOpen ? (adminSidebarClosing ? 'slideOutLeft 0.3s ease' : 'slideInLeft 0.3s ease') : ''
      }}>
        <div className="admin-sidebar-header">
          <h2>Admin Panel</h2>
        </div>
        <nav className="admin-nav">
          <button 
            className="admin-nav-item"
            onClick={() => setInventoryExpanded(!inventoryExpanded)}
          >
            <span className="nav-icon">📦</span>
            Manage Inventory
            <span className={`expand-icon ${inventoryExpanded ? 'expanded' : ''}`}>▼</span>
          </button>
          
          {inventoryExpanded && (
            <div className="admin-submenu">
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'categories' ? 'active' : ''}`}
                onClick={() => setActiveTab('categories')}
              >
                <span className="nav-icon">📁</span>
                Create Category
              </button>
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'products' ? 'active' : ''}`}
                onClick={() => setActiveTab('products')}
              >
                <span className="nav-icon">➕</span>
                Create Product
              </button>
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'manageProducts' ? 'active' : ''}`}
                onClick={() => setActiveTab('manageProducts')}
              >
                <span className="nav-icon">📋</span>
                Manage Products
              </button>
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'customFields' ? 'active' : ''}`}
                onClick={() => setActiveTab('customFields')}
              >
                <span className="nav-icon">⚙️</span>
                Custom Fields
              </button>
            </div>
          )}
          
          <button 
            className="admin-nav-item"
            onClick={() => setOrdersExpanded(!ordersExpanded)}
          >
            <span className="nav-icon">🛒</span>
            Manage Orders
            <span className={`expand-icon ${ordersExpanded ? 'expanded' : ''}`}>▼</span>
          </button>
          
          {ordersExpanded && (
            <div className="admin-submenu">
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'orders' ? 'active' : ''}`}
                onClick={() => setActiveTab('orders')}
              >
                <span className="nav-icon">📋</span>
                All Orders
              </button>
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'orderDetails' ? 'active' : ''}`}
                onClick={() => setActiveTab('orderDetails')}
              >
                <span className="nav-icon">📊</span>
                Order Analytics
              </button>
            </div>
          )}
          
          <button 
            className="admin-nav-item"
            onClick={() => setUsersExpanded(!usersExpanded)}
          >
            <span className="nav-icon">👥</span>
            Manage Users
            <span className={`expand-icon ${usersExpanded ? 'expanded' : ''}`}>▼</span>
          </button>
          
          {usersExpanded && (
            <div className="admin-submenu">
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'createUser' ? 'active' : ''}`}
                onClick={() => setActiveTab('createUser')}
              >
                <span className="nav-icon">➕</span>
                Create User
              </button>
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'manageUsers' ? 'active' : ''}`}
                onClick={() => setActiveTab('manageUsers')}
              >
                <span className="nav-icon">📋</span>
                Manage Users
              </button>
            </div>
          )}
          
          <button 
            className="admin-nav-item"
            onClick={() => setAreasExpanded(!areasExpanded)}
          >
            <span className="nav-icon">🗺️</span>
            Manage Areas
            <span className={`expand-icon ${areasExpanded ? 'expanded' : ''}`}>▼</span>
          </button>
          
          {areasExpanded && (
            <div className="admin-submenu">
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'createProvince' ? 'active' : ''}`}
                onClick={() => setActiveTab('createProvince')}
              >
                <span className="nav-icon">🏛️</span>
                Create Province
              </button>
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'createCity' ? 'active' : ''}`}
                onClick={() => setActiveTab('createCity')}
              >
                <span className="nav-icon">🏙️</span>
                Create City
              </button>
              <button 
                className={`admin-nav-item submenu-item ${activeTab === 'createDistrict' ? 'active' : ''}`}
                onClick={() => setActiveTab('createDistrict')}
              >
                <span className="nav-icon">📍</span>
                Create District
              </button>
            </div>
          )}
          
          <button 
            className={`admin-nav-item ${activeTab === 'slider' ? 'active' : ''}`}
            onClick={() => setActiveTab('slider')}
          >
            <span className="nav-icon">🖼️</span>
            Manage Slider
          </button>

          <button 
            className={`admin-nav-item ${activeTab === 'feedback' ? 'active' : ''}`}
            onClick={() => setActiveTab('feedback')}
          >
            <span className="nav-icon">💬</span>
            Manage Feedback
          </button>
          
          <button 
            className={`admin-nav-item ${activeTab === 'backup' ? 'active' : ''}`}
            onClick={() => setActiveTab('backup')}
          >
            <span className="nav-icon">💾</span>
            Database Backup
          </button>
        </nav>
        {adminSidebarOpen && (
          <button 
            onClick={closeAdminSidebar}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: '28px',
              cursor: 'pointer',
              display: 'none'
            }}
            className="admin-sidebar-close"
          >
            ×
          </button>
        )}
      </aside>

      {adminSidebarOpen && (
        <div 
          onClick={closeAdminSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 998,
            animation: adminSidebarClosing ? 'fadeOut 0.3s ease' : 'fadeIn 0.3s ease'
          }}
          className="admin-sidebar-overlay"
        />
      )}

      <main className="admin-main">
        <div className="admin-content">
          {activeTab === 'categories' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Categories</h1>
                <button 
                  className="btn-primary"
                  onClick={() => setShowCategoryForm(!showCategoryForm)}
                >
                  + Add Category
                </button>
              </div>

              {showCategoryForm && (
                <div className="form-card">
                  <h3>Create New Category</h3>
                  <form onSubmit={handleCreateCategory}>
                    <div className="form-field">
                      <label>Category Name</label>
                      <input
                        type="text"
                        placeholder="Enter category name"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-actions">
                      <button type="submit" className="btn-primary">Create</button>
                      <button 
                        type="button" 
                        className="btn-secondary"
                        onClick={() => setShowCategoryForm(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              )}

              <div className="data-table">
                <table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Products</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((cat) => (
                      <tr key={cat.id}>
                        <td>{cat.id}</td>
                        <td><strong>{cat.name}</strong></td>
                        <td>{products.filter(p => p.category === cat.name).length}</td>
                        <td>{cat.created_at ? new Date(cat.created_at).toLocaleDateString() : '-'}</td>
                        <td>
                          <div style={{display: 'flex', gap: '8px'}}>
                            <button 
                              className="btn-primary" 
                              style={{padding: '6px 12px', fontSize: '12px'}}
                              onClick={() => handleEditCategory(cat)}
                            >
                              ✏️ Edit
                            </button>
                            <button 
                              className="btn-secondary" 
                              style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}}
                              onClick={() => handleDeleteCategory(cat)}
                            >
                              🗑️ Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'customFields' && (
            <CustomFieldsSection
              customFields={customFields}
              newFieldName={newFieldName}
              setNewFieldName={setNewFieldName}
              newFieldType={newFieldType}
              setNewFieldType={setNewFieldType}
              handleAddCustomField={handleAddCustomField}
              handleDeleteCustomField={handleDeleteCustomField}
              defaultFields={defaultFields}
              hiddenFields={hiddenFields}
              handleToggleDefaultField={handleToggleDefaultField}
              handleEditFieldLabel={handleEditFieldLabel}
            />
          )}

          {activeTab === 'products' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Products</h1>
              </div>

              <div className="form-card">
                <h3>Create New Product</h3>
                <form onSubmit={handleCreateProduct}>
                  <div className="form-row">
                    {!hiddenFields.includes('name') && (
                    <div className="form-field">
                      <label>Product Name</label>
                      <input
                        type="text"
                        placeholder="Enter product name"
                        value={productData.name}
                        onChange={(e) => setProductData({ ...productData, name: e.target.value })}
                        required
                      />
                    </div>
                    )}

                    {!hiddenFields.includes('category') && (
                    <div className="form-field">
                      <label>Category</label>
                      <select
                        value={productData.category}
                        onChange={(e) => setProductData({ ...productData, category: e.target.value })}
                        required
                      >
                        <option value="">Select Category</option>
                        {categories.map((cat) => (
                          <option key={cat.id} value={cat.name}>{cat.name}</option>
                        ))}
                      </select>
                    </div>
                    )}
                  </div>

                  {!hiddenFields.includes('description') && (
                  <div className="form-field">
                    <label>Description</label>
                    <ReactQuill
                      theme="snow"
                      value={productData.description}
                      onChange={(value) => setProductData({ ...productData, description: value })}
                      modules={quillModules}
                      formats={quillFormats}
                      placeholder="Enter product description"
                      style={{background: '#fff', borderRadius: '4px'}}
                    />
                  </div>
                  )}

                  <div className="form-row">
                    {!hiddenFields.includes('part_type') && (
                    <div className="form-field">
                      <label>Part Type</label>
                      <input
                        type="text"
                        placeholder="Enter part type"
                        value={productData.part_type}
                        onChange={(e) => setProductData({ ...productData, part_type: e.target.value })}
                      />
                    </div>
                    )}

                    {!hiddenFields.includes('size') && (
                    <div className="form-field">
                      <label>Size</label>
                      <input
                        type="text"
                        placeholder="Enter size"
                        value={productData.size}
                        onChange={(e) => setProductData({ ...productData, size: e.target.value })}
                      />
                    </div>
                    )}
                  </div>

                  <div className="form-row">
                    {!hiddenFields.includes('brand') && (
                    <div className="form-field">
                      <label>Brand</label>
                      <input
                        type="text"
                        placeholder="Enter brand"
                        value={productData.brand}
                        onChange={(e) => setProductData({ ...productData, brand: e.target.value })}
                      />
                    </div>
                    )}

                    {!hiddenFields.includes('usage') && (
                    <div className="form-field">
                      <label>Usage/Application</label>
                      <input
                        type="text"
                        placeholder="Enter usage"
                        value={productData.usage}
                        onChange={(e) => setProductData({ ...productData, usage: e.target.value })}
                      />
                    </div>
                    )}
                  </div>

                  <div className="form-row">
                    {!hiddenFields.includes('material') && (
                    <div className="form-field">
                      <label>Material</label>
                      <input
                        type="text"
                        placeholder="Enter material"
                        value={productData.material}
                        onChange={(e) => setProductData({ ...productData, material: e.target.value })}
                      />
                    </div>
                    )}

                    {!hiddenFields.includes('weight') && (
                    <div className="form-field">
                      <label>Weight</label>
                      <input
                        type="text"
                        placeholder="Enter weight"
                        value={productData.weight}
                        onChange={(e) => setProductData({ ...productData, weight: e.target.value })}
                      />
                    </div>
                    )}
                  </div>

                  <div className="form-row">
                    {!hiddenFields.includes('model_number') && (
                    <div className="form-field">
                      <label>Model Name/Number</label>
                      <input
                        type="text"
                        placeholder="Enter model number"
                        value={productData.model_number}
                        onChange={(e) => setProductData({ ...productData, model_number: e.target.value })}
                      />
                    </div>
                    )}

                    {!hiddenFields.includes('equipment_type') && (
                    <div className="form-field">
                      <label>Equipment Type</label>
                      <input
                        type="text"
                        placeholder="Enter equipment type"
                        value={productData.equipment_type}
                        onChange={(e) => setProductData({ ...productData, equipment_type: e.target.value })}
                      />
                    </div>
                    )}
                  </div>

                  <div className="form-row">
                    {!hiddenFields.includes('packaging_size') && (
                    <div className="form-field">
                      <label>Packaging Size</label>
                      <input
                        type="text"
                        placeholder="Enter packaging size"
                        value={productData.packaging_size}
                        onChange={(e) => setProductData({ ...productData, packaging_size: e.target.value })}
                      />
                    </div>
                    )}

                    {!hiddenFields.includes('packaging_type') && (
                    <div className="form-field">
                      <label>Packaging Type</label>
                      <input
                        type="text"
                        placeholder="Enter packaging type"
                        value={productData.packaging_type}
                        onChange={(e) => setProductData({ ...productData, packaging_type: e.target.value })}
                      />
                    </div>
                    )}
                  </div>

                  <div className="form-field" style={{marginTop: '20px', padding: '20px', background: '#f0f8ff', borderRadius: '8px', border: '2px solid #2196f3'}}>
                    <h3 style={{marginBottom: '16px', color: '#2196f3', display: 'flex', alignItems: 'center', gap: '8px'}}>
                      <span>🛡️</span> Service & Warranty
                    </h3>
                    <div className="form-row">
                      <div className="form-field">
                        <label>Warranty</label>
                        <input
                          type="text"
                          placeholder="e.g., 1 Year Warranty, 6 Months Warranty"
                          value={productData.warranty}
                          onChange={(e) => setProductData({ ...productData, warranty: e.target.value })}
                        />
                      </div>
                      <div className="form-field">
                        <label>Return Policy</label>
                        <input
                          type="text"
                          placeholder="e.g., 7 Days Return, No Return"
                          value={productData.return_policy}
                          onChange={(e) => setProductData({ ...productData, return_policy: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>

                  {customFields.map((field) => (
                    <div key={field.id} className="form-row">
                      <div className="form-field">
                        <label>{field.label}</label>
                        {field.type === 'textarea' ? (
                          <textarea
                            placeholder={`Enter ${field.label.toLowerCase()}`}
                            value={productData[field.name] || ''}
                            onChange={(e) => setProductData({ ...productData, [field.name]: e.target.value })}
                          />
                        ) : (
                          <input
                            type={field.type}
                            placeholder={`Enter ${field.label.toLowerCase()}`}
                            value={productData[field.name] || ''}
                            onChange={(e) => setProductData({ ...productData, [field.name]: e.target.value })}
                          />
                        )}
                      </div>
                    </div>
                  ))}

                  <div className="form-row">
                    {!hiddenFields.includes('price') && (
                    <div className="form-field">
                      <label>Price (Rs.)</label>
                      <input
                        type="number"
                        placeholder="0.00"
                        value={productData.price}
                        onChange={(e) => setProductData({ ...productData, price: e.target.value })}
                        required
                      />
                    </div>
                    )}
                    <div className="form-field">
                      <label>Previous Price (Rs.) - Optional</label>
                      <input
                        type="number"
                        placeholder="0.00"
                        value={productData.previous_price}
                        onChange={(e) => setProductData({ ...productData, previous_price: e.target.value })}
                      />
                    </div>
                    {!hiddenFields.includes('stock') && (
                    <div className="form-field">
                      <label>Stock</label>
                      <input
                        type="number"
                        placeholder="0"
                        value={productData.stock}
                        onChange={(e) => setProductData({ ...productData, stock: e.target.value })}
                        required
                      />
                    </div>
                    )}
                  </div>

                  <div className="form-field">
                    <label style={{display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer'}}>
                      <input
                        type="checkbox"
                        checked={productData.in_stock}
                        onChange={(e) => setProductData({ ...productData, in_stock: e.target.checked })}
                        style={{width: '20px', height: '20px', cursor: 'pointer'}}
                      />
                      <span style={{fontSize: '16px', fontWeight: '600'}}>In Stock</span>
                    </label>
                  </div>

                  {!hiddenFields.includes('image') && (
                  <div className="form-field">
                    <label>Product Images (Multiple)</label>
                    <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                      <div style={{flex: 1}}>
                        <label style={{fontSize: '12px', marginBottom: '4px', display: 'block'}}>Image URL</label>
                        <div style={{display: 'flex', gap: '8px'}}>
                          <input
                            type="text"
                            placeholder="https://example.com/image.jpg"
                            value={urlImageForCrop}
                            onChange={(e) => setUrlImageForCrop(e.target.value)}
                            style={{flex: 1}}
                          />
                          <button 
                            type="button"
                            className="btn-primary"
                            onClick={() => {
                              if (!urlImageForCrop) {
                                alert('Please enter image URL');
                                return;
                              }
                              const choice = window.confirm('Click OK to CROP & UPLOAD\nClick CANCEL to use DIRECT URL');
                              if (choice) {
                                // Crop & Upload
                                handleUrlImageCrop();
                              } else {
                                // Direct URL
                                const currentImages = productData.images || [];
                                const newImages = [...currentImages, urlImageForCrop];
                                setProductData({ 
                                  ...productData, 
                                  image: currentImages.length === 0 ? urlImageForCrop : productData.image,
                                  images: newImages
                                });
                                setUrlImageForCrop('');
                                alert('Direct URL added!');
                              }
                            }}
                            style={{padding: '8px 16px'}}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                      <div style={{flex: 1}}>
                        <label style={{fontSize: '12px', marginBottom: '4px', display: 'block'}}>Upload Image</label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageUpload}
                        />
                      </div>
                    </div>
                    {(productData.images?.length > 0 || productData.image) && (
                      <div style={{marginTop: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                        {(productData.images?.length > 0 ? productData.images : [productData.image]).filter(Boolean).map((img, index) => (
                          <div key={index} style={{position: 'relative', border: img === productData.image ? '3px solid #2196f3' : '1px solid #ddd', borderRadius: '4px', cursor: 'pointer'}} onClick={() => setProductData({...productData, image: img})}>
                            <img 
                              src={img} 
                              alt={`Preview ${index + 1}`} 
                              style={{width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px'}} 
                              onError={(e) => {
                                e.target.style.background = '#f0f0f0';
                                e.target.style.display = 'flex';
                                e.target.style.alignItems = 'center';
                                e.target.style.justifyContent = 'center';
                                e.target.alt = '❌ Failed';
                              }}
                            />
                            <button 
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                const newImages = productData.images?.length > 0 ? productData.images.filter((_, i) => i !== index) : [];
                                setProductData({...productData, images: newImages, image: newImages[0] || ''});
                              }}
                              style={{position: 'absolute', top: '-5px', right: '-5px', background: '#f44336', color: '#fff', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '12px'}}
                            >×</button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  )}

                  <div className="form-actions">
                    <button type="submit" className="btn-primary">Create Product</button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {activeTab === 'manageProducts' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Manage Products</h1>
                <button className="btn-primary" onClick={loadProducts}>
                  🔄 Refresh
                </button>
              </div>
              <div className="data-table">
                <table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Image</th>
                      <th>Name</th>
                      <th>Category</th>
                      <th>Price</th>
                      <th>Stock</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.length === 0 ? (
                      <tr>
                        <td colSpan="7" style={{textAlign: 'center', padding: '40px'}}>No products yet</td>
                      </tr>
                    ) : (
                      products.map((product) => (
                        <tr key={product.id}>
                          <td><strong>#{product.id}</strong></td>
                          <td>
                            <img 
                              src={product.image || 'https://placehold.co/60x60/e0e0e0/666?text=No+Image'} 
                              alt={product.name}
                              style={{width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px'}}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://placehold.co/60x60/e0e0e0/666?text=No+Image';
                              }}
                            />
                          </td>
                          <td><strong>{product.name}</strong></td>
                          <td>{product.category}</td>
                          <td><strong>Rs. {product.price}</strong></td>
                          <td>{product.stock}</td>
                          <td>
                            <div style={{display: 'flex', gap: '8px'}}>
                              <button 
                                className="btn-primary" 
                                style={{padding: '6px 12px', fontSize: '12px'}}
                                onClick={() => {
                                  console.log('Edit button clicked', product);
                                  let images = [];
                                  try {
                                    if (Array.isArray(product.images)) {
                                      images = product.images;
                                    } else if (product.images && typeof product.images === 'string') {
                                      let parsed = product.images;
                                      // Handle multiple levels of encoding
                                      while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                        try {
                                          parsed = JSON.parse(parsed);
                                        } catch {
                                          break;
                                        }
                                      }
                                      images = Array.isArray(parsed) ? parsed : [];
                                    }
                                  } catch (e) {
                                    console.error('Failed to parse images:', e);
                                    images = [];
                                  }
                                  setEditingProduct({
                                    ...product,
                                    images: images,
                                    warranty: product.warranty || '',
                                    return_policy: product.return_policy || ''
                                  });
                                  setShowEditModal(true);
                                }}
                              >
                                ✏️ Edit
                              </button>
                              <button 
                                className="btn-secondary" 
                                style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}}
                                onClick={() => handleDeleteProduct(product)}
                              >
                                🗑️ Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'orders' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Orders</h1>
                <div style={{display: 'flex', gap: '10px'}}>
                  <button 
                    className="btn-primary" 
                    onClick={() => setShowStatusAutomationModal(true)}
                    style={{background: '#9c27b0'}}
                  >
                    ⚙️ Status Automation
                  </button>
                  <button className="btn-primary" onClick={loadOrders}>
                    🔄 Refresh
                  </button>
                </div>
              </div>
              <div style={{display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap'}}>
                <select
                  value={selectedStatusFilter}
                  onChange={(e) => setSelectedStatusFilter(e.target.value)}
                  style={{padding: '10px 16px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', minWidth: '150px'}}
                >
                  <option value="all">All Status</option>
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="processing">Processing</option>
                  <option value="packed">Packed</option>
                  <option value="shipped">Shipped</option>
                  <option value="out_for_delivery">Out for Delivery</option>
                  <option value="delivered">Delivered</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="returned">Returned</option>
                </select>
                <select
                  value={selectedProvinceFilter}
                  onChange={(e) => {
                    setSelectedProvinceFilter(e.target.value);
                    setSelectedCityFilter('');
                    setSelectedDistrictFilter('');
                  }}
                  style={{padding: '10px 16px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', minWidth: '150px'}}
                >
                  <option value="">All Provinces</option>
                  {provinces.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
                <select
                  value={selectedCityFilter}
                  onChange={(e) => {
                    setSelectedCityFilter(e.target.value);
                    setSelectedDistrictFilter('');
                  }}
                  disabled={!selectedProvinceFilter}
                  style={{padding: '10px 16px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', minWidth: '150px'}}
                >
                  <option value="">All Cities</option>
                  {cities.filter(c => c.province_id == selectedProvinceFilter).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
                <select
                  value={selectedDistrictFilter}
                  onChange={(e) => setSelectedDistrictFilter(e.target.value)}
                  disabled={!selectedCityFilter}
                  style={{padding: '10px 16px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', minWidth: '150px'}}
                >
                  <option value="">All Districts</option>
                  {districts.filter(d => d.city_id == selectedCityFilter).map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                </select>
                <input
                  type="date"
                  placeholder="From Date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  style={{padding: '10px 16px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', cursor: 'pointer', minWidth: '150px'}}
                />
                <input
                  type="date"
                  placeholder="To Date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  style={{padding: '10px 16px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', cursor: 'pointer', minWidth: '150px'}}
                />
                <input
                  type="text"
                  placeholder="Search by Order ID, Name, Phone..."
                  value={orderSearchTerm}
                  onChange={(e) => setOrderSearchTerm(e.target.value)}
                  style={{padding: '10px 16px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', width: '250px'}}
                />
              </div>
              <div className="data-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sr#</th>
                      <th>Order No.</th>
                      <th>Customer Name</th>
                      <th>Phone</th>
                      <th>Email</th>
                      <th>Address</th>
                      <th>Total</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.filter(order => {
                      const orderDate = new Date(order.created_at).toISOString().split('T')[0];
                      const matchesStatus = selectedStatusFilter === 'all' || order.status === selectedStatusFilter;
                      const matchesProvince = selectedProvinceFilter === '' || order.province_id == selectedProvinceFilter;
                      const matchesCity = selectedCityFilter === '' || order.city_id == selectedCityFilter;
                      const matchesDistrict = selectedDistrictFilter === '' || order.district_id == selectedDistrictFilter;
                      const matchesSearch = orderSearchTerm === '' || 
                        order.id.toString().includes(orderSearchTerm) ||
                        (order.tracking_id && order.tracking_id.includes(orderSearchTerm)) ||
                        (order.customer_name && order.customer_name.toLowerCase().includes(orderSearchTerm.toLowerCase())) ||
                        (order.customer_phone && order.customer_phone.includes(orderSearchTerm)) ||
                        (order.customer_email && order.customer_email.toLowerCase().includes(orderSearchTerm.toLowerCase()));
                      const matchesFromDate = !fromDate || orderDate >= fromDate;
                      const matchesToDate = !toDate || orderDate <= toDate;
                      return matchesStatus && matchesProvince && matchesCity && matchesDistrict && matchesSearch && matchesFromDate && matchesToDate;
                    }).length === 0 ? (
                      <tr>
                        <td colSpan="10" style={{textAlign: 'center', padding: '40px'}}>No orders found</td>
                      </tr>
                    ) : (
                      orders.filter(order => {
                        const orderDate = new Date(order.created_at).toISOString().split('T')[0];
                        const matchesStatus = selectedStatusFilter === 'all' || order.status === selectedStatusFilter;
                        const matchesProvince = selectedProvinceFilter === '' || order.province_id == selectedProvinceFilter;
                        const matchesCity = selectedCityFilter === '' || order.city_id == selectedCityFilter;
                        const matchesDistrict = selectedDistrictFilter === '' || order.district_id == selectedDistrictFilter;
                        const matchesSearch = orderSearchTerm === '' || 
                          order.id.toString().includes(orderSearchTerm) ||
                          (order.tracking_id && order.tracking_id.includes(orderSearchTerm)) ||
                          (order.customer_name && order.customer_name.toLowerCase().includes(orderSearchTerm.toLowerCase())) ||
                          (order.customer_phone && order.customer_phone.includes(orderSearchTerm)) ||
                          (order.customer_email && order.customer_email.toLowerCase().includes(orderSearchTerm.toLowerCase()));
                        const matchesFromDate = !fromDate || orderDate >= fromDate;
                        const matchesToDate = !toDate || orderDate <= toDate;
                        return matchesStatus && matchesProvince && matchesCity && matchesDistrict && matchesSearch && matchesFromDate && matchesToDate;
                      }).map((order, index) => {
                        const filteredOrders = orders.filter(o => {
                          const orderDate = new Date(o.created_at).toISOString().split('T')[0];
                          const matchesStatus = selectedStatusFilter === 'all' || o.status === selectedStatusFilter;
                          const matchesProvince = selectedProvinceFilter === '' || o.province_id == selectedProvinceFilter;
                          const matchesCity = selectedCityFilter === '' || o.city_id == selectedCityFilter;
                          const matchesDistrict = selectedDistrictFilter === '' || o.district_id == selectedDistrictFilter;
                          const matchesSearch = orderSearchTerm === '' || 
                            o.id.toString().includes(orderSearchTerm) ||
                            (o.tracking_id && o.tracking_id.includes(orderSearchTerm)) ||
                            (o.customer_name && o.customer_name.toLowerCase().includes(orderSearchTerm.toLowerCase())) ||
                            (o.customer_phone && o.customer_phone.includes(orderSearchTerm)) ||
                            (o.customer_email && o.customer_email.toLowerCase().includes(orderSearchTerm.toLowerCase()));
                          const matchesFromDate = !fromDate || orderDate >= fromDate;
                          const matchesToDate = !toDate || orderDate <= toDate;
                          return matchesStatus && matchesProvince && matchesCity && matchesDistrict && matchesSearch && matchesFromDate && matchesToDate;
                        });
                        return (
                        <tr key={order.id}>
                          <td><strong>{filteredOrders.length - index}</strong></td>
                          <td><strong>{order.tracking_id || 'N/A'}</strong></td>
                          <td>{order.customer_name || 'N/A'}</td>
                          <td>{order.customer_phone || 'N/A'}</td>
                          <td>{order.customer_email || 'N/A'}</td>
                          <td style={{maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                            {order.customer_address || 'N/A'}
                          </td>
                          <td><strong>Rs. {order.total}</strong></td>
                          <td>
                            <select 
                              value={order.status}
                              onChange={(e) => handleStatusChange(order.id, e.target.value)}
                              style={{
                                padding: '6px 12px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                background: order.status === 'delivered' ? '#4caf50' : 
                                           order.status === 'out_for_delivery' ? '#00bcd4' :
                                           order.status === 'shipped' ? '#2196f3' : 
                                           order.status === 'packed' ? '#03a9f4' :
                                           order.status === 'processing' ? '#9c27b0' :
                                           order.status === 'confirmed' ? '#8bc34a' :
                                           order.status === 'cancelled' ? '#f44336' :
                                           order.status === 'returned' ? '#ff5722' : '#ff9800',
                                color: '#fff',
                                fontWeight: '600',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              <option value="pending">Pending</option>
                              <option value="confirmed">Confirmed</option>
                              <option value="processing">Processing</option>
                              <option value="packed">Packed</option>
                              <option value="shipped">Shipped</option>
                              <option value="out_for_delivery">Out for Delivery</option>
                              <option value="delivered">Delivered</option>
                              <option value="cancelled">Cancelled</option>
                              <option value="returned">Returned</option>
                            </select>
                          </td>
                          <td>{new Date(order.created_at).toLocaleDateString()}</td>
                          <td>
                            <div style={{display: 'flex', gap: '8px'}}>
                              <button 
                                className="btn-primary" 
                                style={{padding: '6px 12px', fontSize: '12px'}}
                                onClick={() => handleViewOrder(order)}
                              >
                                👁️ View
                              </button>
                              <button 
                                className="btn-secondary" 
                                style={{padding: '6px 12px', fontSize: '12px'}}
                                onClick={() => handleEditOrder(order)}
                              >
                                ✏️ Edit
                              </button>
                              <button 
                                className="btn-secondary" 
                                style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}}
                                onClick={() => handleDeleteOrder(order)}
                              >
                                🗑️ Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'orderDetails' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Order Details & Analytics</h1>
                <button className="btn-primary" onClick={loadOrders}>
                  🔄 Refresh
                </button>
              </div>

              {/* Order Statistics */}
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px'}}>
                <div style={{background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(255,152,0,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('pending')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Pending</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'pending').length}</div>
                </div>
                <div style={{background: 'linear-gradient(135deg, #8bc34a 0%, #689f38 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(139,195,74,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('confirmed')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Confirmed</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'confirmed').length}</div>
                </div>
                <div style={{background: 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(156,39,176,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('processing')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Processing</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'processing').length}</div>
                </div>
                <div style={{background: 'linear-gradient(135deg, #03a9f4 0%, #0288d1 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(3,169,244,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('packed')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Packed</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'packed').length}</div>
                </div>
                <div style={{background: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(33,150,243,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('shipped')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Shipped</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'shipped').length}</div>
                </div>
                <div style={{background: 'linear-gradient(135deg, #00bcd4 0%, #0097a7 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(0,188,212,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('out_for_delivery')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Out for Delivery</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'out_for_delivery').length}</div>
                </div>
                <div style={{background: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(76,175,80,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('delivered')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Delivered</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'delivered').length}</div>
                </div>
                <div style={{background: 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(244,67,54,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('cancelled')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Cancelled</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'cancelled').length}</div>
                </div>
                <div style={{background: 'linear-gradient(135deg, #ff5722 0%, #e64a19 100%)', padding: '25px', borderRadius: '12px', color: '#fff', boxShadow: '0 4px 12px rgba(255,87,34,0.3)', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter('returned')}>
                  <div style={{fontSize: '14px', opacity: '0.9', marginBottom: '8px'}}>Returned</div>
                  <div style={{fontSize: '36px', fontWeight: 'bold'}}>{orders.filter(o => o.status === 'returned').length}</div>
                </div>
              </div>

              {/* Visual Graph */}
              <div style={{background: '#fff', padding: '30px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginBottom: '30px'}}>
                <h3 style={{marginBottom: '25px', padding: '5px', color: '#333'}}>Order Status Distribution</h3>
                <div style={{display: 'flex', alignItems: 'flex-end', gap: '15px', height: '250px', padding: '20px', background: '#f9fafb', borderRadius: '8px'}}>
                  {[
                    {status: 'pending', color: '#ff9800', count: orders.filter(o => o.status === 'pending').length},
                    {status: 'confirmed', color: '#8bc34a', count: orders.filter(o => o.status === 'confirmed').length},
                    {status: 'processing', color: '#9c27b0', count: orders.filter(o => o.status === 'processing').length},
                    {status: 'packed', color: '#03a9f4', count: orders.filter(o => o.status === 'packed').length},
                    {status: 'shipped', color: '#2196f3', count: orders.filter(o => o.status === 'shipped').length},
                    {status: 'out_for_delivery', color: '#00bcd4', count: orders.filter(o => o.status === 'out_for_delivery').length},
                    {status: 'delivered', color: '#4caf50', count: orders.filter(o => o.status === 'delivered').length},
                    {status: 'cancelled', color: '#f44336', count: orders.filter(o => o.status === 'cancelled').length},
                    {status: 'returned', color: '#ff5722', count: orders.filter(o => o.status === 'returned').length}
                  ].map((item, index) => {
                    const maxCount = Math.max(...orders.map(o => orders.filter(ord => ord.status === o.status).length), 1);
                    const height = orders.length > 0 ? (item.count / maxCount) * 100 : 0;
                    return (
                      <div key={index} style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', cursor: 'pointer'}} onClick={() => setSelectedStatusFilter(item.status)}>
                        <div style={{fontSize: '16px', fontWeight: 'bold', color: '#333'}}>{item.count}</div>
                        <div style={{width: '100%', height: `${height}%`, minHeight: '20px', background: item.color, borderRadius: '8px 8px 0 0', transition: 'height 0.3s ease', boxShadow: `0 -2px 8px ${item.color}40`}}></div>
                        <div style={{fontSize: '11px', color: '#666', textAlign: 'center', wordBreak: 'break-word', textTransform: 'capitalize'}}>{item.status.replace('_', ' ')}</div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Filter Header */}
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', padding: '15px 20px', background: '#f9fafb', borderRadius: '8px'}}>
                <h3 style={{margin: 0, padding: '5px', color: '#333'}}>Filtered Orders: {selectedStatusFilter === 'all' ? 'All' : selectedStatusFilter.replace('_', ' ').toUpperCase()}</h3>
                <select 
                  value={selectedStatusFilter} 
                  onChange={(e) => setSelectedStatusFilter(e.target.value)}
                  style={{padding: '10px 16px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', minWidth: '200px'}}
                >
                  <option value="all">All Orders</option>
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="processing">Processing</option>
                  <option value="packed">Packed</option>
                  <option value="shipped">Shipped</option>
                  <option value="out_for_delivery">Out for Delivery</option>
                  <option value="delivered">Delivered</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="returned">Returned</option>
                </select>
              </div>

              {/* Orders Table */}
              <div className="data-table">
                <table>
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Customer Name</th>
                      <th>Phone</th>
                      <th>Total</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(selectedStatusFilter === 'all' ? orders : orders.filter(o => o.status === selectedStatusFilter)).length === 0 ? (
                      <tr>
                        <td colSpan="7" style={{textAlign: 'center', padding: '40px'}}>No orders found</td>
                      </tr>
                    ) : (
                      (selectedStatusFilter === 'all' ? orders : orders.filter(o => o.status === selectedStatusFilter)).map((order) => (
                        <tr key={order.id}>
                          <td><strong>#{order.id}</strong></td>
                          <td>{order.customer_name || 'N/A'}</td>
                          <td>{order.customer_phone || 'N/A'}</td>
                          <td><strong>Rs. {order.total}</strong></td>
                          <td><span className="badge">{order.status}</span></td>
                          <td>{new Date(order.created_at).toLocaleDateString()}</td>
                          <td>
                            <button 
                              className="btn-primary" 
                              style={{padding: '6px 12px', fontSize: '12px'}}
                              onClick={() => handleViewOrder(order)}
                            >
                              👁️ View
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'createUser' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Create New User</h1>
              </div>
              <div className="form-card">
                <h3>User Information</h3>
                <form onSubmit={(e) => {
                  e.preventDefault();
                  alert('User creation functionality - Connect to backend API');
                }}>
                  <div className="form-row">
                    <div className="form-field">
                      <label>Full Name</label>
                      <input type="text" placeholder="Enter full name" required />
                    </div>
                    <div className="form-field">
                      <label>Email</label>
                      <input type="email" placeholder="Enter email" required />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label>Password</label>
                      <div style={{position: 'relative'}}>
                        <input 
                          type={showPassword ? 'text' : 'password'} 
                          placeholder="Enter password" 
                          required 
                          style={{paddingRight: '45px'}}
                        />
                        <button 
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '5px'}}
                        >
                          {showPassword ? (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                              <circle cx="12" cy="12" r="3"/>
                            </svg>
                          ) : (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
                              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                              <line x1="1" y1="1" x2="23" y2="23"/>
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                    <div className="form-field">
                      <label>Role</label>
                      <select required>
                        <option value="">Select Role</option>
                        <option value="admin">Admin</option>
                        <option value="manager">Manager</option>
                        <option value="customer">Customer</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="btn-primary">Create User</button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {activeTab === 'manageUsers' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Manage Users</h1>
                <button className="btn-primary" onClick={loadUsers}>
                  🔄 Refresh
                </button>
              </div>
              <div className="data-table">
                <table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr key={user.id}>
                        <td><strong>#{user.id}</strong></td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td><span className="badge">{user.role}</span></td>
                        <td>{user.created_at}</td>
                        <td>
                          <div style={{display: 'flex', gap: '8px'}}>
                            <button 
                              className="btn-primary" 
                              style={{padding: '6px 12px', fontSize: '12px'}}
                              onClick={() => {
                                setEditingUser(user);
                                setEditUserName(user.name);
                                setEditUserEmail(user.email);
                                setEditUserPassword('');
                                setEditUserRole(user.role);
                                setShowEditUserModal(true);
                              }}
                            >
                              ✏️ Edit
                            </button>
                            {user.id !== 1 && (
                              <button 
                                className="btn-secondary" 
                                style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}}
                                onClick={() => {
                                  setDeletingUser(user);
                                  setShowDeleteUserModal(true);
                                }}
                              >
                                🗑️ Delete
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {activeTab === 'createProvince' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Create Province</h1>
              </div>
              <div className="form-card">
                <h3>Add New Province</h3>
                <form onSubmit={handleCreateProvince}>
                  <div className="form-field">
                    <label>Province Name</label>
                    <input type="text" placeholder="Enter province name" value={provinceName} onChange={(e) => setProvinceName(e.target.value)} required />
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="btn-primary">Create</button>
                  </div>
                </form>
              </div>
              <div className="data-table" style={{marginTop: '30px'}}>
                <h3>All Provinces</h3>
                <table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {provinces.map((prov) => (
                      <tr key={prov.id}>
                        <td>{prov.id}</td>
                        <td>{prov.name}</td>
                        <td>{new Date(prov.created_at).toLocaleDateString()}</td>
                        <td>
                          <div style={{display: 'flex', gap: '8px'}}>
                            <button className="btn-primary" style={{padding: '6px 12px', fontSize: '12px'}} onClick={() => setEditingProvince({...prov, originalId: prov.id})}>Edit</button>
                            <button className="btn-secondary" style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}} onClick={() => handleDeleteProvince(prov.id)}>Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'createCity' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Create City</h1>
              </div>
              <div className="form-card">
                <h3>Add New City</h3>
                <form onSubmit={handleCreateCity}>
                  <div className="form-field">
                    <label>Province</label>
                    <select value={selectedProvince} onChange={(e) => setSelectedProvince(e.target.value)} required>
                      <option value="">Select Province</option>
                      {provinces.map((prov) => (
                        <option key={prov.id} value={prov.id}>{prov.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-field">
                    <label>City Name</label>
                    <input type="text" placeholder="Enter city name" value={cityName} onChange={(e) => setCityName(e.target.value)} required />
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="btn-primary">Create</button>
                  </div>
                </form>
              </div>
              <div className="data-table" style={{marginTop: '30px'}}>
                <h3>All Cities</h3>
                <table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Province</th>
                      <th>City Name</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cities.map((city) => (
                      <tr key={city.id}>
                        <td>{city.id}</td>
                        <td>{provinces.find(p => p.id === city.province_id)?.name}</td>
                        <td>{city.name}</td>
                        <td>{new Date(city.created_at).toLocaleDateString()}</td>
                        <td>
                          <div style={{display: 'flex', gap: '8px'}}>
                            <button className="btn-primary" style={{padding: '6px 12px', fontSize: '12px'}} onClick={() => setEditingCity(city)}>Edit</button>
                            <button className="btn-secondary" style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}} onClick={() => handleDeleteCity(city.id)}>Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'createDistrict' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Create District</h1>
              </div>
              <div className="form-card">
                <h3>Add New District</h3>
                <form onSubmit={handleCreateDistrict}>
                  <div className="form-field">
                    <label>City</label>
                    <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)} required>
                      <option value="">Select City</option>
                      {cities.map((city) => (
                        <option key={city.id} value={city.id}>{city.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-field">
                    <label>District Name</label>
                    <input type="text" placeholder="Enter district name" value={districtName} onChange={(e) => setDistrictName(e.target.value)} required />
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="btn-primary">Create</button>
                  </div>
                </form>
              </div>
              <div className="data-table" style={{marginTop: '30px'}}>
                <h3>All Districts</h3>
                <table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>City</th>
                      <th>District Name</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {districts.map((dist) => (
                      <tr key={dist.id}>
                        <td>{dist.id}</td>
                        <td>{cities.find(c => c.id === dist.city_id)?.name}</td>
                        <td>{dist.name}</td>
                        <td>{new Date(dist.created_at).toLocaleDateString()}</td>
                        <td>
                          <div style={{display: 'flex', gap: '8px'}}>
                            <button className="btn-primary" style={{padding: '6px 12px', fontSize: '12px'}} onClick={() => setEditingDistrict(dist)}>Edit</button>
                            <button className="btn-secondary" style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}} onClick={() => handleDeleteDistrict(dist.id)}>Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'slider' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Manage Hero Slider</h1>
                <button className="btn-primary" onClick={() => setShowSlideForm(!showSlideForm)}>+ Add Slide</button>
              </div>

              {showSlideForm && (
                <div className="form-card">
                  <h3>Create New Slide</h3>
                  <form onSubmit={handleCreateSlide}>
                    <div className="form-row">
                      <div className="form-field">
                        <label>Title</label>
                        <input type="text" value={slideData.title} onChange={(e) => setSlideData({...slideData, title: e.target.value})} required />
                      </div>
                      <div className="form-field">
                        <label>Subtitle</label>
                        <input type="text" value={slideData.subtitle} onChange={(e) => setSlideData({...slideData, subtitle: e.target.value})} />
                      </div>
                    </div>
                    <div className="form-field">
                      <label>Description</label>
                      <input type="text" value={slideData.description} onChange={(e) => setSlideData({...slideData, description: e.target.value})} />
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label>Button Text</label>
                        <input type="text" value={slideData.button_text} onChange={(e) => setSlideData({...slideData, button_text: e.target.value})} />
                      </div>
                      <div className="form-field">
                        <label>Background Color</label>
                        <input type="color" value={slideData.bg_color} onChange={(e) => setSlideData({...slideData, bg_color: e.target.value})} />
                      </div>
                      <div className="form-field">
                        <label>Sort Order</label>
                        <input type="number" value={slideData.sort_order} onChange={(e) => setSlideData({...slideData, sort_order: e.target.value})} />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label>Image URL (ya upload karein)</label>
                        <input type="text" placeholder="https://..." value={slideData.image} onChange={(e) => setSlideData({...slideData, image: e.target.value})} />
                      </div>
                      <div className="form-field">
                        <label>Upload Image</label>
                        <input type="file" accept="image/*" onChange={(e) => setSlideImageFile(e.target.files[0])} />
                      </div>
                    </div>
                    <div className="form-field">
                      <label style={{display:'flex', alignItems:'center', gap:'10px', cursor:'pointer'}}>
                        <input type="checkbox" checked={slideData.is_active == 1} onChange={(e) => setSlideData({...slideData, is_active: e.target.checked ? 1 : 0})} style={{width:'20px', height:'20px'}} />
                        <span style={{fontWeight:'600'}}>Active (show on website)</span>
                      </label>
                    </div>
                    <div className="form-actions">
                      <button type="submit" className="btn-primary">Create Slide</button>
                      <button type="button" className="btn-secondary" onClick={() => setShowSlideForm(false)}>Cancel</button>
                    </div>
                  </form>
                </div>
              )}

              <div className="data-table">
                <table>
                  <thead>
                    <tr>
                      <th>Order</th>
                      <th>Image</th>
                      <th>Title</th>
                      <th>Subtitle</th>
                      <th>Button</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {slides.length === 0 ? (
                      <tr><td colSpan="7" style={{textAlign:'center', padding:'40px'}}>No slides yet. Run slider_table.sql first.</td></tr>
                    ) : (
                      slides.map((slide) => (
                        <tr key={slide.id}>
                          <td>{slide.sort_order}</td>
                          <td>
                            <img src={slide.image} alt={slide.title} style={{width:'80px', height:'50px', objectFit:'cover', borderRadius:'4px'}} onError={(e) => { e.target.onerror=null; e.target.src='https://placehold.co/80x50/e0e0e0/666?text=No+Img'; }} />
                          </td>
                          <td><strong>{slide.title}</strong></td>
                          <td>{slide.subtitle}</td>
                          <td>{slide.button_text}</td>
                          <td><span style={{padding:'4px 10px', borderRadius:'12px', fontSize:'12px', fontWeight:'600', background: slide.is_active == 1 ? '#e8f5e9' : '#ffebee', color: slide.is_active == 1 ? '#2e7d32' : '#c62828'}}>{slide.is_active == 1 ? 'Active' : 'Inactive'}</span></td>
                          <td>
                            <div style={{display:'flex', gap:'8px'}}>
                              <button className="btn-primary" style={{padding:'6px 12px', fontSize:'12px'}} onClick={() => setEditingSlide({...slide})}>✏️ Edit</button>
                              <button className="btn-secondary" style={{padding:'6px 12px', fontSize:'12px', background:'#ff4444', color:'#fff', border:'none'}} onClick={() => handleDeleteSlide(slide.id)}>🗑️ Delete</button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'feedback' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Manage Feedback</h1>
                <button className="btn-primary" onClick={loadFeedbacks}>
                  🔄 Refresh
                </button>
              </div>
              <div className="data-table">
                <table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Product</th>
                      <th>Customer</th>
                      <th>Rating</th>
                      <th>Comment</th>
                      <th>Image</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {feedbacks.length === 0 ? (
                      <tr>
                        <td colSpan="8" style={{textAlign: 'center', padding: '40px'}}>No feedback yet</td>
                      </tr>
                    ) : (
                      feedbacks.map((feedback) => (
                        <tr key={feedback.id}>
                          <td><strong>#{feedback.id}</strong></td>
                          <td>{products.find(p => p.id == feedback.product_id)?.name || 'N/A'}</td>
                          <td>
                            <div>{feedback.customer_name}</div>
                            <div style={{fontSize: '12px', color: '#666'}}>{feedback.customer_phone}</div>
                          </td>
                          <td>
                            <div style={{color: '#ffc107', fontSize: '18px'}}>{'★'.repeat(feedback.rating)}{'☆'.repeat(5 - feedback.rating)}</div>
                          </td>
                          <td style={{maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{feedback.comment || '-'}</td>
                          <td>
                            {feedback.image ? (
                              <img src={feedback.image} alt="Feedback" style={{width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px'}} />
                            ) : '-'}
                          </td>
                          <td>{new Date(feedback.created_at).toLocaleDateString()}</td>
                          <td>
                            <div style={{display: 'flex', gap: '8px'}}>
                              <button 
                                className="btn-primary" 
                                style={{padding: '6px 12px', fontSize: '12px'}}
                                onClick={() => {
                                  setEditingFeedback(feedback);
                                  setShowEditFeedbackModal(true);
                                }}
                              >
                                ✏️ Edit
                              </button>
                              <button 
                                className="btn-secondary" 
                                style={{padding: '6px 12px', fontSize: '12px', background: '#ff4444', color: '#fff', border: 'none'}}
                                onClick={() => {
                                  setDeletingFeedback(feedback);
                                  setShowDeleteFeedbackModal(true);
                                }}
                              >
                                🗑️ Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'backup' && (
            <div className="admin-section">
              <div className="section-header">
                <h1>Database Backup & Restore</h1>
              </div>
              
              <div className="form-card" style={{textAlign: 'center', padding: '60px 40px', marginBottom: '30px'}}>
                <div style={{fontSize: '80px', marginBottom: '20px'}}>💾</div>
                <h2 style={{marginBottom: '16px', color: '#333'}}>Download Database Backup</h2>
                <p style={{color: '#666', marginBottom: '30px', lineHeight: '1.6'}}>Click the button below to download a complete backup of your database including all tables and data.</p>
                <a 
                  href={`${api.baseURL}/backup.php?action=download`}
                  download
                  style={{display: 'inline-block', padding: '14px 32px', background: '#2196f3', color: '#fff', textDecoration: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer'}}
                >
                  ⬇️ Download Backup
                </a>
              </div>

              <div className="form-card" style={{textAlign: 'center', padding: '60px 40px'}}>
                <div style={{fontSize: '80px', marginBottom: '20px'}}>📂</div>
                <h2 style={{marginBottom: '16px', color: '#333'}}>Restore Database Backup</h2>
                <p style={{color: '#666', marginBottom: '30px', lineHeight: '1.6'}}>Upload a backup SQL file to restore your database. This will replace all current data.</p>
                <form onSubmit={async (e) => {
                  e.preventDefault();
                  const fileInput = e.target.querySelector('input[type="file"]');
                  if (!fileInput.files[0]) {
                    alert('Please select a file');
                    return;
                  }
                  if (!window.confirm('This will replace all current data. Are you sure?')) {
                    return;
                  }
                  const formData = new FormData();
                  formData.append('backup_file', fileInput.files[0]);
                  try {
                    const response = await fetch(`${api.baseURL}/backup.php`, {
                      method: 'POST',
                      body: formData
                    });
                    const result = await response.json();
                    if (result.success) {
                      alert('Backup restored successfully!');
                      window.location.reload();
                    } else {
                      alert('Failed: ' + result.message);
                    }
                  } catch (error) {
                    alert('Error: ' + error.message);
                  }
                }}>
                  <input type="file" accept=".sql" style={{marginBottom: '20px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} />
                  <br />
                  <button type="submit" style={{padding: '14px 32px', background: '#4caf50', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer'}}>
                    ⬆️ Restore Backup
                  </button>
                </form>
                <div style={{marginTop: '30px', padding: '20px', background: '#ffebee', borderRadius: '8px', border: '1px solid #f44336'}}>
                  <strong style={{color: '#c62828'}}>⚠️ Warning:</strong>
                  <p style={{color: '#c62828', margin: '8px 0 0 0', fontSize: '14px'}}>Restoring will delete all current data and replace it with backup data.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

      {showOrderModal && selectedOrder && (
        <div className="modal-overlay" onClick={() => setShowOrderModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '700px'}}>
            <div className="modal-header">
              <h2>Order Details #{selectedOrder.id}</h2>
              <button className="modal-close" onClick={() => setShowOrderModal(false)}>×</button>
            </div>
            <div style={{padding: '24px'}}>
              <div style={{marginBottom: '16px'}}>
                <strong>Customer Name:</strong> {selectedOrder.customer_name || 'N/A'}
              </div>
              <div style={{marginBottom: '16px'}}>
                <strong>Phone:</strong> {selectedOrder.customer_phone || 'N/A'}
              </div>
              <div style={{marginBottom: '16px'}}>
                <strong>Email:</strong> {selectedOrder.customer_email || 'N/A'}
              </div>
              <div style={{marginBottom: '16px'}}>
                <strong>Province:</strong> {provinces.find(p => p.id == selectedOrder.province_id)?.name || 'N/A'}
              </div>
              <div style={{marginBottom: '16px'}}>
                <strong>City:</strong> {cities.find(c => c.id == selectedOrder.city_id)?.name || 'N/A'}
              </div>
              <div style={{marginBottom: '16px'}}>
                <strong>District:</strong> {districts.find(d => d.id == selectedOrder.district_id)?.name || 'N/A'}
              </div>
              <div style={{marginBottom: '16px'}}>
                <strong>Address:</strong> {selectedOrder.customer_address || 'N/A'}
              </div>
              <div style={{marginBottom: '16px'}}>
                <strong>Status:</strong> <span className="badge">{selectedOrder.status}</span>
              </div>
              <div style={{marginBottom: '16px'}}>
                <strong>Date:</strong> {new Date(selectedOrder.created_at).toLocaleString()}
              </div>
              
              <hr style={{margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />
              
              <h3 style={{marginBottom: '16px'}}>Order Items</h3>
              {selectedOrder.items && selectedOrder.items.length > 0 ? (
                <div>
                  {selectedOrder.items.map((item, index) => (
                    <div key={index} style={{display: 'flex', gap: '16px', padding: '12px', background: '#f9fafb', marginBottom: '8px', borderRadius: '4px'}}>
                      <div style={{flex: 1}}>
                        <div style={{fontWeight: '600', marginBottom: '4px'}}>{item.product_name}</div>
                        <div style={{fontSize: '14px', color: '#666'}}>Quantity: {item.quantity}</div>
                        <div style={{fontSize: '14px', color: '#666'}}>Price: Rs. {item.price}</div>
                      </div>
                      <div style={{fontWeight: '700', color: '#2874f0'}}>
                        Rs. {(item.price * item.quantity).toFixed(2)}
                      </div>
                    </div>
                  ))}
                  <div style={{textAlign: 'right', marginTop: '16px', padding: '12px', background: '#e8f0fe', borderRadius: '4px'}}>
                    <strong style={{padding: '5px'}}>Total: Rs. {selectedOrder.total}</strong>
                  </div>
                </div>
              ) : (
                <p>No items found</p>
              )}
            </div>
          </div>
        </div>
      )}

      {showDeleteProductModal && deletingProduct && (
        <div className="modal-overlay" onClick={() => setShowDeleteProductModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '460px', borderRadius: '8px', background: '#f5f5f5'}}>
            <div style={{padding: '40px 32px', textAlign: 'center'}}>
              <div style={{width: '70px', height: '70px', border: '4px solid #ff9800', borderRadius: '50%', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <span style={{fontSize: '42px', color: '#ff9800', fontWeight: '700'}}>!</span>
              </div>
              <h2 style={{fontSize: '24px', fontWeight: '600', color: '#333', marginBottom: '16px'}}>Are you sure?</h2>
              <p style={{fontSize: '15px', color: '#666', lineHeight: '1.6', marginBottom: '32px'}}>
                Are you sure you want to delete <strong>{deletingProduct.name}</strong>? This action cannot be undone.
              </p>
              <div style={{display: 'flex', gap: '12px', justifyContent: 'center'}}>
                <button 
                  style={{background: '#f44336', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer', transition: 'all 0.3s'}}
                  onMouseOver={(e) => e.target.style.background = '#d32f2f'}
                  onMouseOut={(e) => e.target.style.background = '#f44336'}
                  onClick={confirmDeleteProduct}
                >
                  Yes, Continue!
                </button>
                <button 
                  style={{background: '#2196f3', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer'}}
                  onClick={() => setShowDeleteProductModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDeleteOrderModal && deletingOrder && (
        <div className="modal-overlay" onClick={() => setShowDeleteOrderModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '460px', borderRadius: '8px', background: '#f5f5f5'}}>
            <div style={{padding: '40px 32px', textAlign: 'center'}}>
              <div style={{width: '70px', height: '70px', border: '4px solid #ff9800', borderRadius: '50%', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <span style={{fontSize: '42px', color: '#ff9800', fontWeight: '700'}}>!</span>
              </div>
              <h2 style={{fontSize: '24px', fontWeight: '600', color: '#333', marginBottom: '16px'}}>Are you sure?</h2>
              <p style={{fontSize: '15px', color: '#666', lineHeight: '1.6', marginBottom: '32px'}}>
                Are you sure you want to delete <strong>Order #{deletingOrder.id}</strong>? This action cannot be undone.
              </p>
              <div style={{display: 'flex', gap: '12px', justifyContent: 'center'}}>
                <button 
                  style={{background: '#f44336', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer', transition: 'all 0.3s'}}
                  onMouseOver={(e) => e.target.style.background = '#d32f2f'}
                  onMouseOut={(e) => e.target.style.background = '#f44336'}
                  onClick={confirmDeleteOrder}
                >
                  Yes, Continue!
                </button>
                <button 
                  style={{background: '#2196f3', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer'}}
                  onClick={() => setShowDeleteOrderModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDeleteCategoryModal && deletingCategory && (
        <div className="modal-overlay" onClick={() => setShowDeleteCategoryModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '460px', borderRadius: '8px', background: '#f5f5f5'}}>
            <div style={{padding: '40px 32px', textAlign: 'center'}}>
              <div style={{width: '70px', height: '70px', border: '4px solid #ff9800', borderRadius: '50%', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <span style={{fontSize: '42px', color: '#ff9800', fontWeight: '700'}}>!</span>
              </div>
              <h2 style={{fontSize: '24px', fontWeight: '600', color: '#333', marginBottom: '16px'}}>Are you sure?</h2>
              <p style={{fontSize: '15px', color: '#666', lineHeight: '1.6', marginBottom: '32px'}}>
                Are you sure you want to delete <strong>{deletingCategory.name}</strong>? This action cannot be undone.
              </p>
              <div style={{display: 'flex', gap: '12px', justifyContent: 'center'}}>
                <button 
                  style={{background: '#f44336', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer', transition: 'all 0.3s'}}
                  onMouseOver={(e) => e.target.style.background = '#d32f2f'}
                  onMouseOut={(e) => e.target.style.background = '#f44336'}
                  onClick={confirmDeleteCategory}
                >
                  Yes, Continue!
                </button>
                <button 
                  style={{background: '#2196f3', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer'}}
                  onClick={() => setShowDeleteCategoryModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditCategoryModal && editingCategory && (
        <div className="modal-overlay" onClick={() => setShowEditCategoryModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '400px'}}>
            <div className="modal-header">
              <h2>Edit Category</h2>
              <button className="modal-close" onClick={() => setShowEditCategoryModal(false)}>×</button>
            </div>
            <form onSubmit={handleUpdateCategory} style={{padding: '24px'}}>
              <div className="form-field">
                <label>Category Name</label>
                <input
                  type="text"
                  value={editCategoryName}
                  onChange={(e) => setEditCategoryName(e.target.value)}
                  required
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update</button>
                <button type="button" className="btn-secondary" onClick={() => setShowEditCategoryModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showEditModal && editingProduct && (
        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '600px'}}>
            <div className="modal-header">
              <h2>Edit Product</h2>
              <button className="modal-close" onClick={() => setShowEditModal(false)}>×</button>
            </div>
            <form onSubmit={handleUpdateProduct} style={{padding: '24px'}}>
              <div className="form-field">
                <label>Product Name</label>
                <input
                  type="text"
                  value={editingProduct.name || ''}
                  onChange={(e) => setEditingProduct({...editingProduct, name: e.target.value})}
                  required
                />
              </div>
              <div className="form-field">
                <label>Description</label>
                <ReactQuill
                  theme="snow"
                  value={editingProduct.description || ''}
                  onChange={(value) => setEditingProduct({...editingProduct, description: value})}
                  modules={quillModules}
                  formats={quillFormats}
                  placeholder="Enter product description"
                  style={{background: '#fff', borderRadius: '4px'}}
                />
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Price</label>
                  <input
                    type="number"
                    value={editingProduct.price || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, price: e.target.value})}
                    required
                  />
                </div>
                <div className="form-field">
                  <label>Previous Price (Optional)</label>
                  <input
                    type="number"
                    value={editingProduct.previous_price || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, previous_price: e.target.value})}
                  />
                </div>
                <div className="form-field">
                  <label>Stock</label>
                  <input
                    type="number"
                    value={editingProduct.stock || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, stock: e.target.value})}
                    required
                  />
                </div>
              </div>
              <div className="form-field">
                <label style={{display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer'}}>
                  <input
                    type="checkbox"
                    checked={editingProduct.in_stock !== false}
                    onChange={(e) => setEditingProduct({...editingProduct, in_stock: e.target.checked})}
                    style={{width: '20px', height: '20px', cursor: 'pointer'}}
                  />
                  <span style={{fontSize: '16px', fontWeight: '600'}}>In Stock</span>
                </label>
              </div>
              <div className="form-field">
                <label>Product Image</label>
                <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                  <div style={{flex: 1}}>
                    <label style={{fontSize: '12px', marginBottom: '4px', display: 'block'}}>Image URL</label>
                    <div style={{display: 'flex', gap: '8px'}}>
                      <input
                        type="text"
                        value={editingProduct.image || ''}
                        onChange={(e) => setEditingProduct({...editingProduct, image: e.target.value})}
                        style={{flex: 1}}
                        placeholder="Enter image URL"
                      />
                      <button 
                        type="button"
                        className="btn-primary"
                        onClick={() => {
                          if (editingProduct.image) {
                            setImageSrc(editingProduct.image);
                            setIsEditingImage(true);
                            setShowCropModal(true);
                          } else {
                            alert('Please enter image URL first');
                          }
                        }}
                        style={{padding: '8px 16px'}}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div style={{flex: 1}}>
                    <label style={{fontSize: '12px', marginBottom: '4px', display: 'block'}}>Upload Image</label>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleEditImageUpload}
                    />
                  </div>
                </div>
                {(() => {
                      let images = [];
                      try {
                        if (Array.isArray(editingProduct.images)) {
                          images = editingProduct.images;
                        } else if (editingProduct.images && typeof editingProduct.images === 'string') {
                          images = JSON.parse(editingProduct.images);
                        }
                      } catch (e) {
                        images = [];
                      }
                      
                      const handleImageClick = (img) => {
                        setEditingProduct({...editingProduct, image: img});
                      };
                      
                      const handleDeleteImage = (index) => {
                        const newImages = images.filter((_, i) => i !== index);
                        setEditingProduct({...editingProduct, images: newImages, image: newImages[0] || ''});
                      };
                      
                      return (images.length > 0 || editingProduct.image) ? (
                        <div style={{marginTop: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                          {images.length > 0 ? 
                            images.map((img, index) => (
                              <div key={index} style={{position: 'relative', border: img === editingProduct.image ? '3px solid #2196f3' : '1px solid #ddd', borderRadius: '4px', cursor: 'pointer'}} onClick={() => handleImageClick(img)}>
                                <img src={img} alt={`Preview ${index + 1}`} style={{width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px'}} />
                                <button 
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteImage(index);
                                  }}
                                  style={{position: 'absolute', top: '-5px', right: '-5px', background: '#f44336', color: '#fff', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '12px'}}
                                >×</button>
                              </div>
                            )) : editingProduct.image ? (
                              <div style={{position: 'relative'}}>
                                <img src={editingProduct.image} alt="Preview" style={{width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd'}} />
                              </div>
                            ) : null
                          }
                        </div>
                      ) : null;
                    })()}
                  </div>
                {(() => {
                      let images = [];
                      try {
                        if (Array.isArray(editingProduct.images)) {
                          images = editingProduct.images;
                        } else if (editingProduct.images && typeof editingProduct.images === 'string') {
                          images = JSON.parse(editingProduct.images);
                        }
                      } catch (e) {
                        images = [];
                      }
                      
                      const handleImageClick = (img) => {
                        setEditingProduct({...editingProduct, image: img});
                      };
                      
                      const handleDeleteImage = (index) => {
                        const newImages = images.filter((_, i) => i !== index);
                        setEditingProduct({...editingProduct, images: newImages, image: newImages[0] || ''});
                      };
                      
                      return (images.length > 0 || editingProduct.image) ? (
                        <div style={{marginTop: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                          {images.length > 0 ? 
                            images.map((img, index) => (
                              <div key={index} style={{position: 'relative', border: img === editingProduct.image ? '3px solid #2196f3' : '1px solid #ddd', borderRadius: '4px', cursor: 'pointer'}} onClick={() => handleImageClick(img)}>
                                <img src={img} alt={`Preview ${index + 1}`} style={{width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px'}} />
                                <button 
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteImage(index);
                                  }}
                                  style={{position: 'absolute', top: '-5px', right: '-5px', background: '#f44336', color: '#fff', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '12px'}}
                                >×</button>
                              </div>
                            )) : editingProduct.image ? (
                              <div style={{position: 'relative'}}>
                                <img src={editingProduct.image} alt="Preview" style={{width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd'}} />
                              </div>
                            ) : null
                          }
                        </div>
                      ) : null;
                    })()}
              <div className="form-field">
                <label>Category</label>
                <select
                  value={editingProduct.category || ''}
                  onChange={(e) => setEditingProduct({...editingProduct, category: e.target.value})}
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.name}>{cat.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Part Type</label>
                  <input
                    type="text"
                    value={editingProduct.part_type || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, part_type: e.target.value})}
                  />
                </div>
                <div className="form-field">
                  <label>Brand</label>
                  <input
                    type="text"
                    value={editingProduct.brand || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, brand: e.target.value})}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Size</label>
                  <input
                    type="text"
                    value={editingProduct.size || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, size: e.target.value})}
                  />
                </div>
                <div className="form-field">
                  <label>Usage</label>
                  <input
                    type="text"
                    value={editingProduct.usage || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, usage: e.target.value})}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Material</label>
                  <input
                    type="text"
                    value={editingProduct.material || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, material: e.target.value})}
                  />
                </div>
                <div className="form-field">
                  <label>Weight</label>
                  <input
                    type="text"
                    value={editingProduct.weight || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, weight: e.target.value})}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Model Number</label>
                  <input
                    type="text"
                    value={editingProduct.model_number || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, model_number: e.target.value})}
                  />
                </div>
                <div className="form-field">
                  <label>Equipment Type</label>
                  <input
                    type="text"
                    value={editingProduct.equipment_type || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, equipment_type: e.target.value})}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Packaging Size</label>
                  <input
                    type="text"
                    value={editingProduct.packaging_size || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, packaging_size: e.target.value})}
                  />
                </div>
                <div className="form-field">
                  <label>Packaging Type</label>
                  <input
                    type="text"
                    value={editingProduct.packaging_type || ''}
                    onChange={(e) => setEditingProduct({...editingProduct, packaging_type: e.target.value})}
                  />
                </div>
              </div>
              <div className="form-field" style={{marginTop: '20px', padding: '20px', background: '#f0f8ff', borderRadius: '8px', border: '2px solid #2196f3'}}>
                <h3 style={{marginBottom: '16px', color: '#2196f3', display: 'flex', alignItems: 'center', gap: '8px'}}>
                  <span>🛡️</span> Service & Warranty
                </h3>
                <div className="form-row">
                  <div className="form-field">
                    <label>Warranty</label>
                    <input
                      type="text"
                      placeholder="e.g., 1 Year Warranty, 6 Months Warranty"
                      value={editingProduct.warranty || ''}
                      onChange={(e) => setEditingProduct({...editingProduct, warranty: e.target.value})}
                    />
                  </div>
                  <div className="form-field">
                    <label>Return Policy</label>
                    <input
                      type="text"
                      placeholder="e.g., 7 Days Return, No Return"
                      value={editingProduct.return_policy || ''}
                      onChange={(e) => setEditingProduct({...editingProduct, return_policy: e.target.value})}
                    />
                  </div>
                </div>
              </div>
              {customFields.map((field) => (
                <div key={field.id} className="form-row">
                  <div className="form-field">
                    <label>{field.label}</label>
                    {field.type === 'textarea' ? (
                      <textarea
                        placeholder={`Enter ${field.label.toLowerCase()}`}
                        value={editingProduct[field.name] || ''}
                        onChange={(e) => setEditingProduct({ ...editingProduct, [field.name]: e.target.value })}
                      />
                    ) : (
                      <input
                        type={field.type}
                        placeholder={`Enter ${field.label.toLowerCase()}`}
                        value={editingProduct[field.name] || ''}
                        onChange={(e) => setEditingProduct({ ...editingProduct, [field.name]: e.target.value })}
                      />
                    )}
                  </div>
                </div>
              ))}
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update Product</button>
                <button type="button" className="btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {editingSlide && (
        <div className="modal-overlay" onClick={() => setEditingSlide(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth:'600px'}}>
            <div className="modal-header">
              <h2>Edit Slide</h2>
              <button className="modal-close" onClick={() => setEditingSlide(null)}>×</button>
            </div>
            <form onSubmit={handleUpdateSlide} style={{padding:'24px'}}>
              <div className="form-row">
                <div className="form-field">
                  <label>Title</label>
                  <input type="text" value={editingSlide.title} onChange={(e) => setEditingSlide({...editingSlide, title: e.target.value})} required />
                </div>
                <div className="form-field">
                  <label>Subtitle</label>
                  <input type="text" value={editingSlide.subtitle || ''} onChange={(e) => setEditingSlide({...editingSlide, subtitle: e.target.value})} />
                </div>
              </div>
              <div className="form-field">
                <label>Description</label>
                <input type="text" value={editingSlide.description || ''} onChange={(e) => setEditingSlide({...editingSlide, description: e.target.value})} />
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Button Text</label>
                  <input type="text" value={editingSlide.button_text || ''} onChange={(e) => setEditingSlide({...editingSlide, button_text: e.target.value})} />
                </div>
                <div className="form-field">
                  <label>Background Color</label>
                  <input type="color" value={editingSlide.bg_color || '#f5f5f5'} onChange={(e) => setEditingSlide({...editingSlide, bg_color: e.target.value})} />
                </div>
                <div className="form-field">
                  <label>Sort Order</label>
                  <input type="number" value={editingSlide.sort_order || 0} onChange={(e) => setEditingSlide({...editingSlide, sort_order: e.target.value})} />
                </div>
              </div>
              <div className="form-field">
                <label>Image URL</label>
                <input type="text" value={editingSlide.image || ''} onChange={(e) => setEditingSlide({...editingSlide, image: e.target.value})} />
                {editingSlide.image && <img src={editingSlide.image} alt="preview" style={{marginTop:'8px', width:'120px', height:'75px', objectFit:'cover', borderRadius:'4px', border:'1px solid #ddd'}} onError={(e) => { e.target.style.display='none'; }} />}
              </div>
              <div className="form-field">
                <label style={{display:'flex', alignItems:'center', gap:'10px', cursor:'pointer'}}>
                  <input type="checkbox" checked={editingSlide.is_active == 1} onChange={(e) => setEditingSlide({...editingSlide, is_active: e.target.checked ? 1 : 0})} style={{width:'20px', height:'20px'}} />
                  <span style={{fontWeight:'600'}}>Active</span>
                </label>
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update Slide</button>
                <button type="button" className="btn-secondary" onClick={() => setEditingSlide(null)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showCropModal && imageSrc && (
        <div className="modal-overlay" onClick={() => setShowCropModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '800px'}}>
            <div className="modal-header">
              <h2>Crop & Adjust Image</h2>
              <button className="modal-close" onClick={() => setShowCropModal(false)}>×</button>
            </div>
            <div style={{padding: '24px'}}>
              <div style={{marginBottom: '16px'}}>
                <label>Zoom: {zoom.toFixed(1)}x</label>
                <input
                  type="range"
                  min="0.5"
                  max="3"
                  step="0.1"
                  value={zoom}
                  onChange={(e) => setZoom(parseFloat(e.target.value))}
                  style={{width: '100%', marginTop: '8px'}}
                />
              </div>
              <div style={{maxHeight: '500px', overflow: 'auto', border: '1px solid #ddd', borderRadius: '4px'}}>
                <ReactCrop
                  crop={crop}
                  onChange={(c) => setCrop(c)}
                  onComplete={(c) => setCompletedCrop(c)}
                >
                  <img
                    src={imageSrc}
                    onLoad={(e) => setImageRef(e.target)}
                    style={{transform: `scale(${zoom})`, transformOrigin: 'center', maxWidth: '100%'}}
                    alt="Crop"
                    crossOrigin="anonymous"
                  />
                </ReactCrop>
              </div>
              <div className="form-actions" style={{marginTop: '16px'}}>
                <button className="btn-primary" onClick={handleCropComplete}>Upload Cropped Image</button>
                <button className="btn-secondary" onClick={() => setShowCropModal(false)}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditOrderModal && editingOrder && (
        <div className="modal-overlay" onClick={() => setShowEditOrderModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '600px', maxHeight: '90vh', overflow: 'auto'}}>
            <div className="modal-header">
              <h2>Edit Order #{editingOrder.id}</h2>
              <button className="modal-close" onClick={() => setShowEditOrderModal(false)}>×</button>
            </div>
            <form onSubmit={handleUpdateOrder} style={{padding: '24px'}}>
              <div className="form-row">
                <div className="form-field">
                  <label>Customer Name</label>
                  <input
                    type="text"
                    value={editingOrder.customer_name || ''}
                    onChange={(e) => setEditingOrder({...editingOrder, customer_name: e.target.value})}
                    required
                  />
                </div>
                <div className="form-field">
                  <label>Phone</label>
                  <input
                    type="tel"
                    value={editingOrder.customer_phone || ''}
                    onChange={(e) => setEditingOrder({...editingOrder, customer_phone: e.target.value})}
                    required
                  />
                </div>
              </div>
              <div className="form-field">
                <label>Email</label>
                <input
                  type="email"
                  value={editingOrder.customer_email || ''}
                  onChange={(e) => setEditingOrder({...editingOrder, customer_email: e.target.value})}
                  required
                />
              </div>
              <div className="form-field">
                <label>Address</label>
                <textarea
                  value={editingOrder.customer_address || ''}
                  onChange={(e) => setEditingOrder({...editingOrder, customer_address: e.target.value})}
                  required
                />
              </div>
              <div className="form-field">
                <label>Order Status</label>
                <select
                  value={editOrderStatus}
                  onChange={(e) => setEditOrderStatus(e.target.value)}
                  required
                >
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="processing">Processing</option>
                  <option value="packed">Packed</option>
                  <option value="shipped">Shipped</option>
                  <option value="out_for_delivery">Out for Delivery</option>
                  <option value="delivered">Delivered</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="returned">Returned</option>
                </select>
              </div>
              <hr style={{margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0'}} />
              <h3 style={{marginBottom: '16px'}}>Order Items</h3>
              {editingOrder.items && editingOrder.items.map((item, index) => (
                <div key={index} style={{padding: '12px', background: '#f9fafb', marginBottom: '12px', borderRadius: '4px'}}>
                  <div className="form-field">
                    <label>Product: {item.product_name}</label>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label>Quantity</label>
                      <input
                        type="number"
                        min="1"
                        value={item.quantity}
                        onChange={(e) => {
                          const updated = [...editingOrder.items];
                          updated[index].quantity = parseInt(e.target.value);
                          const newTotal = updated.reduce((sum, i) => sum + (i.price * i.quantity), 0);
                          setEditingOrder({...editingOrder, items: updated, total: newTotal});
                        }}
                        required
                      />
                    </div>
                    <div className="form-field">
                      <label>Price</label>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={item.price}
                        onChange={(e) => {
                          const updated = [...editingOrder.items];
                          updated[index].price = parseFloat(e.target.value);
                          const newTotal = updated.reduce((sum, i) => sum + (i.price * i.quantity), 0);
                          setEditingOrder({...editingOrder, items: updated, total: newTotal});
                        }}
                        required
                      />
                    </div>
                    <div className="form-field">
                      <label>Subtotal</label>
                      <input
                        type="text"
                        value={`Rs. ${(item.price * item.quantity).toFixed(2)}`}
                        disabled
                        style={{background: '#e0e0e0'}}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <div style={{textAlign: 'right', padding: '12px', background: '#e8f0fe', borderRadius: '4px', marginTop: '16px'}}>
                <strong style={{padding: '5px'}}>Total: Rs. {editingOrder.total}</strong>
              </div>
              <div className="form-actions" style={{marginTop: '24px'}}>
                <button type="submit" className="btn-primary">Update Order</button>
                <button type="button" className="btn-secondary" onClick={() => setShowEditOrderModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showEditFieldModal && editingField && (
        <div className="modal-overlay" onClick={() => setShowEditFieldModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '400px'}}>
            <div className="modal-header">
              <h2>Edit Field Label</h2>
              <button className="modal-close" onClick={() => setShowEditFieldModal(false)}>×</button>
            </div>
            <form onSubmit={handleUpdateFieldLabel} style={{padding: '24px'}}>
              <div className="form-field">
                <label>Field Label</label>
                <input
                  type="text"
                  value={editFieldLabel}
                  onChange={(e) => setEditFieldLabel(e.target.value)}
                  required
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update</button>
                <button type="button" className="btn-secondary" onClick={() => setShowEditFieldModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showEditUserModal && editingUser && (
        <div className="modal-overlay" onClick={() => setShowEditUserModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '500px'}}>
            <div className="modal-header">
              <h2>Edit User</h2>
              <button className="modal-close" onClick={() => setShowEditUserModal(false)}>×</button>
            </div>
            <form onSubmit={async (e) => {
              e.preventDefault();
              const result = await api.updateUser(
                editingUser.id,
                editUserName,
                editUserEmail,
                editUserPassword,
                editUserRole
              );
              if (result.success) {
                const updatedUser = JSON.parse(localStorage.getItem('user'));
                if (updatedUser && updatedUser.id === editingUser.id) {
                  updatedUser.name = editUserName;
                  updatedUser.email = editUserEmail;
                  updatedUser.role = editUserRole;
                  localStorage.setItem('user', JSON.stringify(updatedUser));
                }
                setShowEditUserModal(false);
                setShowPassword(false);
                setEditUserPassword('');
                loadUsers();
                setSuccessMessage('User updated successfully!');
                setShowSuccessPopup(true);
              } else {
                alert('Failed to update user');
              }
            }} style={{padding: '24px'}}>
              <div className="form-field">
                <label>Name</label>
                <input 
                  type="text" 
                  value={editUserName}
                  onChange={(e) => setEditUserName(e.target.value)}
                  required 
                />
              </div>
              <div className="form-field">
                <label>Email</label>
                <input 
                  type="email" 
                  value={editUserEmail}
                  onChange={(e) => setEditUserEmail(e.target.value)}
                  required 
                />
              </div>
              <div className="form-field">
                <label>Password</label>
                <div style={{position: 'relative'}}>
                  <input 
                    type={showPassword ? 'text' : 'password'} 
                    placeholder="Enter new password (leave blank to keep current)" 
                    style={{paddingRight: '45px'}}
                    value={editUserPassword}
                    onChange={(e) => setEditUserPassword(e.target.value)}
                  />
                  <button 
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '5px'}}
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </div>
              <div className="form-field">
                <label>Role</label>
                <select 
                  value={editUserRole}
                  onChange={(e) => setEditUserRole(e.target.value)}
                  required
                >
                  <option value="admin">Admin</option>
                  <option value="manager">Manager</option>
                  <option value="customer">Customer</option>
                </select>
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update</button>
                <button type="button" className="btn-secondary" onClick={() => setShowEditUserModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showDeleteUserModal && deletingUser && (
        <div className="modal-overlay" onClick={() => setShowDeleteUserModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '460px', borderRadius: '8px', background: '#f5f5f5'}}>
            <div style={{padding: '40px 32px', textAlign: 'center'}}>
              <div style={{width: '70px', height: '70px', border: '4px solid #ff9800', borderRadius: '50%', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <span style={{fontSize: '42px', color: '#ff9800', fontWeight: '700'}}>!</span>
              </div>
              <h2 style={{fontSize: '24px', fontWeight: '600', color: '#333', marginBottom: '16px'}}>Are you sure?</h2>
              <p style={{fontSize: '15px', color: '#666', lineHeight: '1.6', marginBottom: '32px'}}>
                Delete user <strong>{deletingUser.name}</strong>? This action cannot be undone.
              </p>
              <div style={{display: 'flex', gap: '12px', justifyContent: 'center'}}>
                <button 
                  style={{background: '#f44336', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer'}}
                  onClick={() => {
                    setShowDeleteUserModal(false);
                    setSuccessMessage('User deleted successfully!');
                    setShowSuccessPopup(true);
                  }}
                >
                  Yes, Delete!
                </button>
                <button 
                  style={{background: '#2196f3', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer'}}
                  onClick={() => setShowDeleteUserModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditFeedbackModal && editingFeedback && (
        <div className="modal-overlay" onClick={() => setShowEditFeedbackModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '500px'}}>
            <div className="modal-header">
              <h2>Edit Feedback</h2>
              <button className="modal-close" onClick={() => setShowEditFeedbackModal(false)}>×</button>
            </div>
            <form onSubmit={async (e) => {
              e.preventDefault();
              try {
                const formData = new FormData();
                formData.append('rating', editingFeedback.rating);
                formData.append('comment', editingFeedback.comment || '');
                if (editFeedbackImage) {
                  formData.append('image', editFeedbackImage);
                }
                
                const response = await fetch(`${api.baseURL}/feedback.php?id=${editingFeedback.id}&action=update`, {
                  method: 'POST',
                  body: formData
                });
                const result = await response.json();
                if (result.success) {
                  setShowEditFeedbackModal(false);
                  setEditingFeedback(null);
                  setEditFeedbackImage(null);
                  setSuccessMessage('Feedback updated successfully!');
                  setShowSuccessPopup(true);
                  loadFeedbacks();
                } else {
                  alert('Failed to update feedback');
                }
              } catch (error) {
                alert('Error updating feedback');
              }
            }} style={{padding: '24px'}}>
              <div className="form-field">
                <label>Rating</label>
                <div style={{display: 'flex', gap: '8px', fontSize: '32px', marginTop: '8px'}}>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      onClick={() => setEditingFeedback({...editingFeedback, rating: star})}
                      style={{cursor: 'pointer', color: star <= editingFeedback.rating ? '#ffc107' : '#ddd'}}
                    >
                      ★
                    </span>
                  ))}
                </div>
              </div>
              <div className="form-field">
                <label>Comment</label>
                <textarea
                  value={editingFeedback.comment || ''}
                  onChange={(e) => setEditingFeedback({...editingFeedback, comment: e.target.value})}
                  rows="4"
                  style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}}
                />
              </div>
              <div className="form-field">
                <label>Image</label>
                {editingFeedback.image && (
                  <div style={{marginBottom: '10px'}}>
                    <img src={editingFeedback.image} alt="Current" style={{width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px'}} />
                  </div>
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setEditFeedbackImage(e.target.files[0])}
                  style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}}
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update</button>
                <button type="button" className="btn-secondary" onClick={() => setShowEditFeedbackModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showDeleteFeedbackModal && deletingFeedback && (
        <div className="modal-overlay" onClick={() => setShowDeleteFeedbackModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '460px', borderRadius: '8px', background: '#f5f5f5'}}>
            <div style={{padding: '40px 32px', textAlign: 'center'}}>
              <div style={{width: '70px', height: '70px', border: '4px solid #ff9800', borderRadius: '50%', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <span style={{fontSize: '42px', color: '#ff9800', fontWeight: '700'}}>!</span>
              </div>
              <h2 style={{fontSize: '24px', fontWeight: '600', color: '#333', marginBottom: '16px'}}>Are you sure?</h2>
              <p style={{fontSize: '15px', color: '#666', lineHeight: '1.6', marginBottom: '32px'}}>
                Delete feedback from <strong>{deletingFeedback.customer_name}</strong>? This action cannot be undone.
              </p>
              <div style={{display: 'flex', gap: '12px', justifyContent: 'center'}}>
                <button 
                  style={{background: '#f44336', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer'}}
                  onClick={async () => {
                    try {
                      const response = await fetch(`${api.baseURL}/feedback.php?id=${deletingFeedback.id}`, {
                        method: 'DELETE'
                      });
                      const result = await response.json();
                      if (result.success) {
                        setShowDeleteFeedbackModal(false);
                        setDeletingFeedback(null);
                        setSuccessMessage('Feedback deleted successfully!');
                        setShowSuccessPopup(true);
                        loadFeedbacks();
                      } else {
                        alert('Failed to delete feedback');
                      }
                    } catch (error) {
                      alert('Error deleting feedback');
                    }
                  }}
                >
                  Yes, Delete!
                </button>
                <button 
                  style={{background: '#2196f3', color: '#fff', border: 'none', padding: '12px 28px', fontSize: '15px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer'}}
                  onClick={() => setShowDeleteFeedbackModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingProvince && (
        <div className="modal-overlay" onClick={() => setEditingProvince(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '400px'}}>
            <div className="modal-header">
              <h2>Edit Province</h2>
              <button className="modal-close" onClick={() => setEditingProvince(null)}>×</button>
            </div>
            <form onSubmit={(e) => {
              e.preventDefault(); 
              const newId = editingProvince.id !== editingProvince.originalId ? editingProvince.id : null;
              handleEditProvince(editingProvince.originalId, editingProvince.name, newId);
            }} style={{padding: '24px'}}>
              <div className="form-field">
                <label>Province ID</label>
                <input 
                  type="number" 
                  value={editingProvince.id} 
                  onChange={(e) => setEditingProvince({...editingProvince, id: e.target.value})} 
                  required 
                />
              </div>
              <div className="form-field">
                <label>Province Name</label>
                <input type="text" value={editingProvince.name} onChange={(e) => setEditingProvince({...editingProvince, name: e.target.value})} required />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update</button>
                <button type="button" className="btn-secondary" onClick={() => setEditingProvince(null)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {editingCity && (
        <div className="modal-overlay" onClick={() => setEditingCity(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '400px'}}>
            <div className="modal-header">
              <h2>Edit City</h2>
              <button className="modal-close" onClick={() => setEditingCity(null)}>×</button>
            </div>
            <form onSubmit={(e) => {e.preventDefault(); handleEditCity(editingCity.id, editingCity.name);}} style={{padding: '24px'}}>
              <div className="form-field">
                <label>City Name</label>
                <input type="text" value={editingCity.name} onChange={(e) => setEditingCity({...editingCity, name: e.target.value})} required />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update</button>
                <button type="button" className="btn-secondary" onClick={() => setEditingCity(null)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {editingDistrict && (
        <div className="modal-overlay" onClick={() => setEditingDistrict(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '400px'}}>
            <div className="modal-header">
              <h2>Edit District</h2>
              <button className="modal-close" onClick={() => setEditingDistrict(null)}>×</button>
            </div>
            <form onSubmit={(e) => {e.preventDefault(); handleEditDistrict(editingDistrict.id, editingDistrict.name);}} style={{padding: '24px'}}>
              <div className="form-field">
                <label>District Name</label>
                <input type="text" value={editingDistrict.name} onChange={(e) => setEditingDistrict({...editingDistrict, name: e.target.value})} required />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Update</button>
                <button type="button" className="btn-secondary" onClick={() => setEditingDistrict(null)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
    {showSuccessPopup && (
      <SuccessPopup 
        message={successMessage} 
        onClose={() => setShowSuccessPopup(false)} 
      />
    )}
    {showStatusAutomationModal && (
      <StatusAutomationModal 
        onClose={() => setShowStatusAutomationModal(false)}
        onSuccess={(msg) => {
          setSuccessMessage(msg);
          setShowSuccessPopup(true);
          loadOrders();
        }}
      />
    )}
    </>
  );
}

export default Admin;


